var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _g2, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _g3, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _g4, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _g5, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _g6, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _g7, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 536,
    viewBox: "0 0 579 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.174 107.603C361.254 114.136 339.324 125.155 316.219 133.559C290.919 142.758 265.312 146.345 237.843 145.611C195.549 144.482 146.463 128.373 105.978 142.936C83.8097 150.913 66.867 169.358 60.3216 190.861C53.7763 212.363 57.3447 236.503 68.7652 256.788C82.7842 281.682 108.813 303.809 107.144 331.428C106.074 349.139 93.216 364.577 94.1923 382.542C95.1109 399.468 107.432 415.72 121.984 425.365C133.907 433.27 147.641 438.213 161.21 443.072C186.946 452.284 212.674 461.495 238.408 470.715C270.075 482.054 303.531 493.591 336.412 488.842C362.375 485.09 385.568 471.146 402.446 452.636C419.323 434.127 430.257 411.262 437.269 387.573C443.51 366.485 447.05 343.991 459.777 325.859C473.986 305.612 497.73 293.488 516.582 276.976C542.189 254.555 559.025 222.256 557.331 188.731C555.644 155.207 533.451 121.465 500.058 108.508C467.75 95.9749 424.739 98.4155 392.119 105.857C389.784 106.393 387.467 106.972 385.174 107.603Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M483.35 318.087H483.658V292.263L482.451 290.668L484.345 256.827L484.327 256.792L453.165 197.321L448.962 195.876L448.918 195.894L306.946 246.07L307.043 246.36L448.971 196.202L452.945 197.577L484.037 256.898L482.142 290.765L483.35 292.369V318.087Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480.151 318.087H480.46V292.369L481.667 290.765V290.713L479.773 256.828L479.755 256.792L450.901 199.207L450.628 199.339L479.464 256.898L481.358 290.669L480.151 292.263V318.087Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 447.045H488.936V442.578H432.24V447.045Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M428.883 453.195H492.292V447.036H428.883V453.195Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M444.724 399.944V378.394H456.803V399.989L452.97 439.697H448.556L444.724 399.944ZM455.878 399.944V379.319H445.649V399.9L449.402 438.772H452.133L455.887 399.944H455.878Z",
    fill: "#B3B3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M456.345 399.478H445.191V400.403H456.345V399.478Z",
    fill: "#B3B3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M450.768 399.583L456.786 378.985L455.896 378.72L450.768 396.288L445.632 378.72L444.742 378.985L450.768 399.583Z",
    fill: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M454.019 419.671L454.926 419.495L450.768 398.068L446.627 419.495L447.534 419.671L450.768 402.94L454.019 419.671Z",
    fill: "#B3B3B3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M451.226 399.944H450.301V439.23H451.226V399.944Z",
    fill: "#B3B3B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M442.768 399.944V378.394H445.649V399.909L448.883 439.697H447.341L442.768 399.944ZM443.694 379.31V399.883L447.174 430.2L444.716 399.936V379.31H443.685H443.694Z",
    fill: "#B3B3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M445.192 399.478H443.236V400.403H445.192V399.478Z",
    fill: "#B3B3B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M444.671 397.962L445.649 378.879L444.724 378.826L444.213 388.878L443.694 378.826L442.768 378.879L443.746 397.962H444.671Z",
    fill: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M444.65 399.919L443.729 400.009L447.582 439.3L448.503 439.21L444.65 399.919Z",
    fill: "#B3B3B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M444.724 235.136L449.472 198.81H452.054L456.803 235.197V254.942H444.724V235.136ZM455.887 235.25L451.243 199.735H450.292L445.658 235.188V254.008H455.887V235.25Z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M456.345 234.73H445.191V235.656H456.345V234.73Z",
    fill: "#B3B3B3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M445.631 254.615L450.768 238.545L455.904 254.615L456.785 254.333L450.768 235.505L444.75 254.333L445.631 254.615Z",
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M450.768 237.215L454.45 217.312L453.543 217.145L450.768 232.14L447.984 217.197L447.076 217.365L450.768 237.215Z",
    fill: "#B3B3B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M451.226 199.268H450.301V235.188H451.226V199.268Z",
    fill: "#B3B3B3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 442.578H452.187V270.959H451.658V442.578Z",
    fill: "#B3B3B3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M449.332 442.578H449.86V270.959H449.332V442.578Z",
    fill: "#B3B3B3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 441.609V441.081H449.87V441.609H451.667Z",
    fill: "#B3B3B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 439.856V439.327H449.86V439.856H451.658Z",
    fill: "#B3B3B3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 438.094V437.565H449.87V438.094H451.667Z",
    fill: "#B3B3B3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 436.34V435.812H449.86V436.34H451.658Z",
    fill: "#B3B3B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 434.578V434.05H449.87V434.578H451.667Z",
    fill: "#B3B3B3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 432.825V432.296H449.86V432.825H451.658Z",
    fill: "#B3B3B3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 431.063V430.534H449.87V431.063H451.667Z",
    fill: "#B3B3B3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 429.309V428.781H449.86V429.309H451.658Z",
    fill: "#B3B3B3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 427.547V427.019H449.87V427.547H451.667Z",
    fill: "#B3B3B3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 425.794V425.266H449.86V425.794H451.658Z",
    fill: "#B3B3B3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 424.032V423.503H449.87V424.032H451.667Z",
    fill: "#B3B3B3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 422.279V421.75H449.86V422.279H451.658Z",
    fill: "#B3B3B3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 420.516V419.988H449.87V420.516H451.667Z",
    fill: "#B3B3B3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 418.763V418.235H449.86V418.763H451.658Z",
    fill: "#B3B3B3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 417.001V416.473H449.87V417.001H451.667Z",
    fill: "#B3B3B3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 415.248V414.719H449.86V415.248H451.658Z",
    fill: "#B3B3B3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 413.486V412.957H449.87V413.486H451.667Z",
    fill: "#B3B3B3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 411.733V411.204H449.86V411.733H451.658Z",
    fill: "#B3B3B3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 409.971V409.442H449.87V409.971H451.667Z",
    fill: "#B3B3B3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 408.217V407.688H449.86V408.217H451.658Z",
    fill: "#B3B3B3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 406.455V405.926H449.86V406.455H451.658Z",
    fill: "#B3B3B3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 404.702V404.173H449.87V404.702H451.667Z",
    fill: "#B3B3B3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 402.94V402.411H449.86V402.94H451.658Z",
    fill: "#B3B3B3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 401.186V400.658H449.87V401.186H451.667Z",
    fill: "#B3B3B3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 399.425V398.896H449.86V399.425H451.658Z",
    fill: "#B3B3B3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 397.671V397.143H449.87V397.671H451.667Z",
    fill: "#B3B3B3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 395.909V395.38H449.86V395.909H451.658Z",
    fill: "#B3B3B3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 394.147V393.618H449.87V394.147H451.667Z",
    fill: "#B3B3B3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 392.394V391.865H449.86V392.394H451.658Z",
    fill: "#B3B3B3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 390.632V390.103H449.87V390.632H451.667Z",
    fill: "#B3B3B3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 388.878V388.35H449.86V388.878H451.658Z",
    fill: "#B3B3B3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 387.116V386.587H449.87V387.116H451.667Z",
    fill: "#B3B3B3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 385.363V384.834H449.86V385.363H451.658Z",
    fill: "#B3B3B3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 383.601V383.072H449.87V383.601H451.667Z",
    fill: "#B3B3B3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 381.847V381.319H449.86V381.847H451.658Z",
    fill: "#B3B3B3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 380.085V379.557H449.87V380.085H451.667Z",
    fill: "#B3B3B3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 378.332V377.804H449.86V378.332H451.658Z",
    fill: "#B3B3B3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 376.57V376.042H449.87V376.57H451.667Z",
    fill: "#B3B3B3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 374.817V374.288H449.86V374.817H451.658Z",
    fill: "#B3B3B3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 373.055V372.526H449.87V373.055H451.667Z",
    fill: "#B3B3B3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 371.302V370.773H449.86V371.302H451.658Z",
    fill: "#B3B3B3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 369.539V369.011H449.87V369.539H451.667Z",
    fill: "#B3B3B3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 367.786V367.257H449.86V367.786H451.658Z",
    fill: "#B3B3B3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 366.024V365.495H449.87V366.024H451.667Z",
    fill: "#B3B3B3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 364.271V363.742H449.86V364.271H451.658Z",
    fill: "#B3B3B3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 362.509V361.98H449.87V362.509H451.667Z",
    fill: "#B3B3B3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 360.755V360.227H449.86V360.755H451.658Z",
    fill: "#B3B3B3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 358.993V358.465H449.87V358.993H451.667Z",
    fill: "#B3B3B3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 357.24V356.711H449.86V357.24H451.658Z",
    fill: "#B3B3B3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 355.478V354.949H449.87V355.478H451.667Z",
    fill: "#B3B3B3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 353.724V353.196H449.86V353.724H451.658Z",
    fill: "#B3B3B3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 351.963V351.434H449.86V351.963H451.658Z",
    fill: "#B3B3B3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 350.209V349.681H449.87V350.209H451.667Z",
    fill: "#B3B3B3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 348.447V347.918H449.86V348.447H451.658Z",
    fill: "#B3B3B3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 346.694V346.165H449.87V346.694H451.667Z",
    fill: "#B3B3B3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 344.932V344.403H449.86V344.932H451.658Z",
    fill: "#B3B3B3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 343.178V342.649H449.87V343.178H451.667Z",
    fill: "#B3B3B3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 341.416V340.888H449.86V341.416H451.658Z",
    fill: "#B3B3B3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 339.654V339.125H449.87V339.654H451.667Z",
    fill: "#B3B3B3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 337.901V337.372H449.86V337.901H451.658Z",
    fill: "#B3B3B3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 336.138V335.61H449.87V336.138H451.667Z",
    fill: "#B3B3B3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 334.386V333.857H449.86V334.386H451.658Z",
    fill: "#B3B3B3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 332.623V332.095H449.87V332.623H451.667Z",
    fill: "#B3B3B3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 330.87V330.341H449.86V330.87H451.658Z",
    fill: "#B3B3B3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 329.108V328.579H449.87V329.108H451.667Z",
    fill: "#B3B3B3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 327.355V326.826H449.86V327.355H451.658Z",
    fill: "#B3B3B3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 325.593V325.064H449.87V325.593H451.667Z",
    fill: "#B3B3B3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 323.839V323.311H449.86V323.839H451.658Z",
    fill: "#B3B3B3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 322.077V321.549H449.87V322.077H451.667Z",
    fill: "#B3B3B3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 320.324V319.795H449.86V320.324H451.658Z",
    fill: "#B3B3B3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 318.562V318.033H449.87V318.562H451.667Z",
    fill: "#B3B3B3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 316.808V316.28H449.86V316.808H451.658Z",
    fill: "#B3B3B3"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 315.047V314.518H449.87V315.047H451.667Z",
    fill: "#B3B3B3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 313.293V312.765H449.86V313.293H451.658Z",
    fill: "#B3B3B3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 311.531V311.002H449.87V311.531H451.667Z",
    fill: "#B3B3B3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 309.778V309.249H449.86V309.778H451.658Z",
    fill: "#B3B3B3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 308.016V307.487H449.87V308.016H451.667Z",
    fill: "#B3B3B3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 306.263V305.734H449.86V306.263H451.658Z",
    fill: "#B3B3B3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 304.5V303.972H449.87V304.5H451.667Z",
    fill: "#B3B3B3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 302.747V302.218H449.86V302.747H451.658Z",
    fill: "#B3B3B3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 300.985V300.457H449.87V300.985H451.667Z",
    fill: "#B3B3B3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 299.232V298.703H449.86V299.232H451.658Z",
    fill: "#B3B3B3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 297.47V296.941H449.86V297.47H451.658Z",
    fill: "#B3B3B3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 295.716V295.188H449.87V295.716H451.667Z",
    fill: "#B3B3B3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 293.954V293.426H449.86V293.954H451.658Z",
    fill: "#B3B3B3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 292.201V291.672H449.87V292.201H451.667Z",
    fill: "#B3B3B3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 290.439V289.91H449.86V290.439H451.658Z",
    fill: "#B3B3B3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 288.686V288.157H449.87V288.686H451.667Z",
    fill: "#B3B3B3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 286.924V286.395H449.86V286.924H451.658Z",
    fill: "#B3B3B3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 285.161V284.633H449.87V285.161H451.667Z",
    fill: "#B3B3B3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 283.408V282.879H449.86V283.408H451.658Z",
    fill: "#B3B3B3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 281.646V281.118H449.87V281.646H451.667Z",
    fill: "#B3B3B3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 279.893V279.364H449.86V279.893H451.658Z",
    fill: "#B3B3B3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 278.131V277.602H449.87V278.131H451.667Z",
    fill: "#B3B3B3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 276.377V275.849H449.86V276.377H451.658Z",
    fill: "#B3B3B3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M451.667 274.616V274.087H449.87V274.616H451.667Z",
    fill: "#B3B3B3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M451.658 272.862V272.333H449.86V272.862H451.658Z",
    fill: "#B3B3B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.658 442.578H452.187V270.959H451.658V442.578Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.332 442.578H449.86V270.959H449.332V442.578Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 441.609V441.081H449.87V441.609H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 439.856V439.327H449.86V439.856H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 438.094V437.565H449.87V438.094H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 436.34V435.812H449.86V436.34H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 434.578V434.05H449.87V434.578H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 432.825V432.296H449.86V432.825H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 431.063V430.534H449.87V431.063H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 429.309V428.781H449.86V429.309H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 427.547V427.019H449.87V427.547H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 425.794V425.266H449.86V425.794H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 424.032V423.503H449.87V424.032H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 422.279V421.75H449.86V422.279H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 420.516V419.988H449.87V420.516H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 418.763V418.235H449.86V418.763H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 417.001V416.473H449.87V417.001H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 415.248V414.719H449.86V415.248H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 413.486V412.957H449.87V413.486H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 411.733V411.204H449.86V411.733H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 409.971V409.442H449.87V409.971H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 408.217V407.688H449.86V408.217H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 406.455V405.926H449.86V406.455H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 404.702V404.173H449.87V404.702H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 402.94V402.411H449.86V402.94H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 401.186V400.658H449.87V401.186H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 399.425V398.896H449.86V399.425H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 397.671V397.143H449.87V397.671H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 395.909V395.38H449.86V395.909H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 394.147V393.618H449.87V394.147H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 392.394V391.865H449.86V392.394H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 390.632V390.103H449.87V390.632H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 388.878V388.35H449.86V388.878H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 387.116V386.587H449.87V387.116H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 385.363V384.834H449.86V385.363H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 383.601V383.072H449.87V383.601H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 381.847V381.319H449.86V381.847H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 380.085V379.557H449.87V380.085H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 378.332V377.804H449.86V378.332H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 376.57V376.042H449.87V376.57H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 374.817V374.288H449.86V374.817H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 373.055V372.526H449.87V373.055H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 371.302V370.773H449.86V371.302H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 369.539V369.011H449.87V369.539H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 367.786V367.257H449.86V367.786H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 366.024V365.495H449.87V366.024H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 364.271V363.742H449.86V364.271H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 362.509V361.98H449.87V362.509H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 360.755V360.227H449.86V360.755H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 358.993V358.465H449.87V358.993H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 357.24V356.711H449.86V357.24H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 355.478V354.949H449.87V355.478H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 353.724V353.196H449.86V353.724H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 351.963V351.434H449.86V351.963H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 350.209V349.681H449.87V350.209H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 348.447V347.918H449.86V348.447H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 346.694V346.165H449.87V346.694H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 344.932V344.403H449.86V344.932H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 343.178V342.649H449.87V343.178H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 341.416V340.888H449.86V341.416H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 339.654V339.125H449.87V339.654H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 337.901V337.372H449.86V337.901H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 336.138V335.61H449.87V336.138H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 334.386V333.857H449.86V334.386H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 332.623V332.095H449.87V332.623H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 330.87V330.341H449.86V330.87H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 329.108V328.579H449.87V329.108H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 327.355V326.826H449.86V327.355H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 325.593V325.064H449.87V325.593H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 323.839V323.311H449.86V323.839H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 322.077V321.549H449.87V322.077H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 320.324V319.795H449.86V320.324H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 318.562V318.033H449.87V318.562H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 316.808V316.28H449.86V316.808H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 315.047V314.518H449.87V315.047H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 313.293V312.765H449.86V313.293H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 311.531V311.002H449.87V311.531H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 309.778V309.249H449.86V309.778H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 308.016V307.487H449.87V308.016H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 306.263V305.734H449.86V306.263H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 304.5V303.972H449.87V304.5H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 302.747V302.218H449.86V302.747H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 300.985V300.457H449.87V300.985H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 299.232V298.703H449.86V299.232H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 297.47V296.941H449.86V297.47H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 295.716V295.188H449.87V295.716H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 293.954V293.426H449.86V293.954H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 292.201V291.672H449.87V292.201H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 290.439V289.91H449.86V290.439H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 288.686V288.157H449.87V288.686H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 286.924V286.395H449.86V286.924H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 285.161V284.633H449.87V285.161H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 283.408V282.879H449.86V283.408H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 281.646V281.118H449.87V281.646H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 279.893V279.364H449.86V279.893H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 278.131V277.602H449.87V278.131H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 276.377V275.849H449.86V276.377H451.658Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 274.616V274.087H449.87V274.616H451.667Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.658 272.862V272.333H449.86V272.862H451.658Z",
    fill: "#151515"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M445.833 270.492H455.692V379.31H445.833V270.492ZM454.767 271.417H446.767V378.385H454.767V271.417Z",
    fill: "#B3B3B3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 379.046L455.658 373.17L446.424 367.302L446.178 367.689L454.794 373.17L446.178 378.658L446.424 379.046Z",
    fill: "#B3B3B3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 367.69L455.658 361.813L446.424 355.945L446.178 356.333L454.794 361.813L446.178 367.302L446.424 367.69Z",
    fill: "#B3B3B3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 367.029H446.301V367.954H455.094V367.029Z",
    fill: "#B3B3B3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 356.333L455.658 350.456L446.424 344.58L446.178 344.976L454.794 350.456L446.178 355.945L446.424 356.333Z",
    fill: "#B3B3B3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 355.672H446.301V356.597H455.094V355.672Z",
    fill: "#B3B3B3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 344.976L455.658 339.1L446.424 333.223L446.178 333.62L454.794 339.1L446.178 344.58L446.424 344.976Z",
    fill: "#B3B3B3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 344.315H446.301V345.241H455.094V344.315Z",
    fill: "#B3B3B3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 333.619L455.658 327.743L446.424 321.866L446.178 322.263L454.794 327.743L446.178 333.223L446.424 333.619Z",
    fill: "#B3B3B3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 332.958H446.301V333.884H455.094V332.958Z",
    fill: "#B3B3B3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 322.263L455.658 316.386L446.424 310.51L446.178 310.906L454.794 316.386L446.178 321.866L446.424 322.263Z",
    fill: "#B3B3B3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 321.602H446.301V322.527H455.094V321.602Z",
    fill: "#B3B3B3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 310.906L455.658 305.029L446.424 299.153L446.178 299.54L454.794 305.029L446.178 310.51L446.424 310.906Z",
    fill: "#B3B3B3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 310.245H446.301V311.17H455.094V310.245Z",
    fill: "#B3B3B3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 299.541L455.658 293.673L446.424 287.796L446.178 288.184L454.794 293.673L446.178 299.153L446.424 299.541Z",
    fill: "#B3B3B3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 298.889H446.301V299.814H455.094V298.889Z",
    fill: "#B3B3B3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M446.424 288.184L455.658 282.316L446.424 276.439L446.178 276.827L454.794 282.316L446.178 287.796L446.424 288.184Z",
    fill: "#B3B3B3"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M455.094 287.532H446.301V288.457H455.094V287.532Z",
    fill: "#B3B3B3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M455.104 270.736L446.176 276.416L446.427 276.81L455.355 271.13L455.104 270.736Z",
    fill: "#B3B3B3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M455.093 276.175H446.3V277.1H455.093V276.175Z",
    fill: "#B3B3B3"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M443.613 270.492H446.767V379.31H443.613V270.492ZM445.834 271.417H444.538V378.385H445.834V271.417Z",
    fill: "#B3B3B3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 378.931L446.512 378.764L444.327 373.169L446.512 367.575L446.089 367.407L443.825 373.169L446.089 378.931Z",
    fill: "#B3B3B3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 367.575L446.512 367.407L444.327 361.813L446.512 356.218L446.089 356.051L443.825 361.813L446.089 367.575Z",
    fill: "#B3B3B3"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 367.028H444.107V367.953H446.301V367.028Z",
    fill: "#B3B3B3"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 356.218L446.512 356.051L444.327 350.456L446.512 344.861L446.089 344.694L443.825 350.456L446.089 356.218Z",
    fill: "#B3B3B3"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 355.672H444.107V356.597H446.301V355.672Z",
    fill: "#B3B3B3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 344.861L446.512 344.694L444.327 339.099L446.512 333.505L446.089 333.337L443.825 339.099L446.089 344.861Z",
    fill: "#B3B3B3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 344.315H444.107V345.24H446.301V344.315Z",
    fill: "#B3B3B3"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 333.505L446.512 333.337L444.327 327.743L446.512 322.148L446.089 321.98L443.825 327.743L446.089 333.505Z",
    fill: "#B3B3B3"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 332.958H444.107V333.884H446.301V332.958Z",
    fill: "#B3B3B3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 322.148L446.512 321.981L444.327 316.386L446.512 310.791L446.089 310.624L443.825 316.386L446.089 322.148Z",
    fill: "#B3B3B3"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 321.602H444.107V322.527H446.301V321.602Z",
    fill: "#B3B3B3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 310.791L446.512 310.624L444.327 305.029L446.512 299.434L446.089 299.267L443.825 305.029L446.089 310.791Z",
    fill: "#B3B3B3"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 310.245H444.107V311.17H446.301V310.245Z",
    fill: "#B3B3B3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 299.434L446.512 299.267L444.327 293.672L446.512 288.078L446.089 287.91L443.825 293.672L446.089 299.434Z",
    fill: "#B3B3B3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 298.888H444.107V299.813H446.301V298.888Z",
    fill: "#B3B3B3"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M446.089 288.078L446.512 287.91L444.327 282.316L446.512 276.721L446.089 276.554L443.825 282.316L446.089 288.078Z",
    fill: "#B3B3B3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M446.301 287.532H444.107V288.457H446.301V287.532Z",
    fill: "#B3B3B3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M444.291 270.873L443.856 271.043L446.08 276.72L446.515 276.55L444.291 270.873Z",
    fill: "#B3B3B3"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M446.3 276.175H444.106V277.1H446.3V276.175Z",
    fill: "#B3B3B3"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M251.148 246.581H445.648V254.942H245.563L251.148 246.581ZM444.723 247.506H251.651L247.298 254.017H444.723V247.506Z",
    fill: "#B3B3B3"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M371.367 254.853L377.226 247.179L376.856 246.897L371.367 254.096L365.87 246.897L365.5 247.179L371.367 254.853Z",
    fill: "#B3B3B3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M382.724 254.853L388.583 247.179L388.213 246.897L382.724 254.096L377.226 246.897L376.856 247.179L382.724 254.853Z",
    fill: "#B3B3B3"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M377.508 247.039H376.583V254.36H377.508V247.039Z",
    fill: "#B3B3B3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M360.002 254.853L365.87 247.179L365.5 246.897L360.002 254.096L354.513 246.897L354.143 247.179L360.002 254.853Z",
    fill: "#B3B3B3"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M366.142 247.039H365.217V254.36H366.142V247.039Z",
    fill: "#B3B3B3"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M348.645 254.853L354.513 247.179L354.143 246.897L348.645 254.096L343.156 246.897L342.786 247.179L348.645 254.853Z",
    fill: "#B3B3B3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M354.786 247.039H353.861V254.36H354.786V247.039Z",
    fill: "#B3B3B3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M337.289 254.853L343.156 247.179L342.786 246.897L337.289 254.096L331.8 246.897L331.43 247.179L337.289 254.853Z",
    fill: "#B3B3B3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M343.43 247.039H342.505V254.36H343.43V247.039Z",
    fill: "#B3B3B3"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M325.932 254.853L331.8 247.179L331.43 246.897L325.932 254.096L320.434 246.897L320.073 247.179L325.932 254.853Z",
    fill: "#B3B3B3"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M332.073 247.039H331.147V254.36H332.073V247.039Z",
    fill: "#B3B3B3"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M314.575 254.853L320.434 247.179L320.073 246.897L314.575 254.096L309.077 246.897L308.716 247.179L314.575 254.853Z",
    fill: "#B3B3B3"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M320.716 247.039H319.791V254.36H320.716V247.039Z",
    fill: "#B3B3B3"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M303.219 254.853L309.078 247.179L308.716 246.897L303.219 254.096L297.721 246.897L297.36 247.179L303.219 254.853Z",
    fill: "#B3B3B3"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M309.36 247.039H308.435V254.36H309.36V247.039Z",
    fill: "#B3B3B3"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M291.862 254.853L297.721 247.179L297.359 246.897L291.862 254.096L286.364 246.897L285.994 247.179L291.862 254.853Z",
    fill: "#B3B3B3"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M298.002 247.039H297.077V254.36H298.002V247.039Z",
    fill: "#B3B3B3"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M280.505 254.853L286.364 247.179L285.994 246.897L280.505 254.096L275.007 246.897L274.637 247.179L280.505 254.853Z",
    fill: "#B3B3B3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M286.646 247.039H285.721V254.36H286.646V247.039Z",
    fill: "#B3B3B3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M269.149 254.853L275.008 247.179L274.638 246.897L269.149 254.096L263.651 246.897L263.281 247.179L269.149 254.853Z",
    fill: "#B3B3B3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M275.29 247.039H274.365V254.36H275.29V247.039Z",
    fill: "#B3B3B3"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M257.791 254.853L263.65 247.179L263.28 246.897L257.791 254.096L252.294 246.897L251.924 247.179L257.791 254.853Z",
    fill: "#B3B3B3"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M263.933 247.039H263.007V254.36H263.933V247.039Z",
    fill: "#B3B3B3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M251.933 246.884L246.254 254.32L246.625 254.603L252.304 247.167L251.933 246.884Z",
    fill: "#B3B3B3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M252.576 247.039H251.651V254.36H252.576V247.039Z",
    fill: "#B3B3B3"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M394.081 254.853L399.94 247.179L399.57 246.897L394.081 254.096L388.583 246.897L388.213 247.179L394.081 254.853Z",
    fill: "#B3B3B3"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M388.865 247.039H387.94V254.36H388.865V247.039Z",
    fill: "#B3B3B3"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M405.437 254.853L411.296 247.179L410.926 246.897L405.437 254.096L399.94 246.897L399.57 247.179L405.437 254.853Z",
    fill: "#B3B3B3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M400.222 247.039H399.297V254.36H400.222V247.039Z",
    fill: "#B3B3B3"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M416.795 254.853L422.654 247.179L422.293 246.897L416.795 254.096L411.297 246.897L410.927 247.179L416.795 254.853Z",
    fill: "#B3B3B3"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M411.578 247.039H410.653V254.36H411.578V247.039Z",
    fill: "#B3B3B3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M428.151 254.853L434.01 247.179L433.649 246.897L428.151 254.096L422.653 246.897L422.292 247.179L428.151 254.853Z",
    fill: "#B3B3B3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M422.935 247.039H422.01V254.36H422.935V247.039Z",
    fill: "#B3B3B3"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M439.507 254.853L445.366 247.179L445.005 246.897L439.507 254.096L434.01 246.897L433.648 247.179L439.507 254.853Z",
    fill: "#B3B3B3"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M434.292 247.039H433.367V254.36H434.292V247.039Z",
    fill: "#B3B3B3"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M445.649 247.039H444.723V254.36H445.649V247.039Z",
    fill: "#B3B3B3"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M246.734 254.008H445.649V257.321H251.475L246.743 254.008H246.734ZM444.723 254.942H249.677L251.765 256.404H444.723V254.942Z",
    fill: "#B3B3B3"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M365.773 257.074L371.368 254.73L376.954 257.074L377.13 256.651L371.368 254.228L365.597 256.651L365.773 257.074Z",
    fill: "#B3B3B3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M377.129 257.074L382.724 254.73L388.31 257.074L388.486 256.651L382.724 254.228L376.953 256.651L377.129 257.074Z",
    fill: "#B3B3B3"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M377.508 254.51H376.583V256.863H377.508V254.51Z",
    fill: "#B3B3B3"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M354.417 257.074L360.003 254.73L365.597 257.074L365.773 256.651L360.003 254.228L354.24 256.651L354.417 257.074Z",
    fill: "#B3B3B3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M366.143 254.51H365.218V256.863H366.143V254.51Z",
    fill: "#B3B3B3"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M343.06 257.074L348.645 254.73L354.24 257.074L354.416 256.651L348.645 254.228L342.883 256.651L343.06 257.074Z",
    fill: "#B3B3B3"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M354.786 254.51H353.861V256.863H354.786V254.51Z",
    fill: "#B3B3B3"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M331.703 257.074L337.289 254.73L342.884 257.074L343.06 256.651L337.289 254.228L331.527 256.651L331.703 257.074Z",
    fill: "#B3B3B3"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M343.43 254.51H342.505V256.863H343.43V254.51Z",
    fill: "#B3B3B3"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M320.346 257.074L325.932 254.73L331.527 257.074L331.703 256.651L325.932 254.228L320.161 256.651L320.346 257.074Z",
    fill: "#B3B3B3"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M332.073 254.51H331.147V256.863H332.073V254.51Z",
    fill: "#B3B3B3"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M320.161 257.074L320.346 256.651L314.576 254.228L308.805 256.651L308.99 257.074L314.576 254.73L320.161 257.074Z",
    fill: "#B3B3B3"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M320.716 254.51H319.791V256.863H320.716V254.51Z",
    fill: "#B3B3B3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M297.632 257.074L303.218 254.73L308.804 257.074L308.989 256.651L303.218 254.228L297.447 256.651L297.632 257.074Z",
    fill: "#B3B3B3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M309.36 254.51H308.435V256.863H309.36V254.51Z",
    fill: "#B3B3B3"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M286.276 257.074L291.862 254.73L297.448 257.074L297.633 256.651L291.862 254.228L286.091 256.651L286.276 257.074Z",
    fill: "#B3B3B3"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M298.002 254.51H297.077V256.863H298.002V254.51Z",
    fill: "#B3B3B3"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M274.911 257.074L280.505 254.73L286.091 257.074L286.276 256.651L280.505 254.228L274.735 256.651L274.911 257.074Z",
    fill: "#B3B3B3"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M286.646 254.51H285.721V256.863H286.646V254.51Z",
    fill: "#B3B3B3"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M263.554 257.074L269.148 254.73L274.734 257.074L274.91 256.651L269.148 254.228L263.377 256.651L263.554 257.074Z",
    fill: "#B3B3B3"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M275.29 254.51H274.365V256.863H275.29V254.51Z",
    fill: "#B3B3B3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M252.197 257.074L257.792 254.73L263.378 257.074L263.554 256.651L257.792 254.228L252.021 256.651L252.197 257.074Z",
    fill: "#B3B3B3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M263.933 254.51H263.007V256.863H263.933V254.51Z",
    fill: "#B3B3B3"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M248.327 254.284L248.084 254.682L251.986 257.065L252.23 256.667L248.327 254.284Z",
    fill: "#B3B3B3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M252.576 254.51H251.651V256.863H252.576V254.51Z",
    fill: "#B3B3B3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M388.487 257.074L394.081 254.73L399.667 257.074L399.843 256.651L394.081 254.228L388.311 256.651L388.487 257.074Z",
    fill: "#B3B3B3"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M388.866 254.51H387.941V256.863H388.866V254.51Z",
    fill: "#B3B3B3"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M399.843 257.074L405.438 254.73L411.024 257.074L411.209 256.651L405.438 254.228L399.667 256.651L399.843 257.074Z",
    fill: "#B3B3B3"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M400.222 254.51H399.297V256.863H400.222V254.51Z",
    fill: "#B3B3B3"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M411.208 257.074L416.794 254.73L422.38 257.074L422.565 256.651L416.794 254.228L411.023 256.651L411.208 257.074Z",
    fill: "#B3B3B3"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M411.578 254.51H410.653V256.863H411.578V254.51Z",
    fill: "#B3B3B3"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M422.566 257.074L428.151 254.73L433.737 257.074L433.922 256.651L428.151 254.228L422.381 256.651L422.566 257.074Z",
    fill: "#B3B3B3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M422.936 254.51H422.011V256.863H422.936V254.51Z",
    fill: "#B3B3B3"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M433.922 257.074L439.508 254.73L445.094 257.074L445.279 256.651L439.508 254.228L433.737 256.651L433.922 257.074Z",
    fill: "#B3B3B3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M434.292 254.51H433.367V256.863H434.292V254.51Z",
    fill: "#B3B3B3"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M445.649 254.51H444.723V256.863H445.649V254.51Z",
    fill: "#B3B3B3"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M443.42 270.959H458.662V254.158H443.42L441.077 262.554L443.42 270.959Z",
    fill: "#B3B3B3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M441.077 262.554L443.42 270.959H447.306L444.962 262.554L447.306 254.158H443.42L441.077 262.554Z",
    fill: "#151515"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M443.896 255.083L441.905 262.211H444.31L446.302 255.083H443.896Z",
    fill: "#999999"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M447.518 255.083L445.527 262.211H452.716V255.083H447.518Z",
    fill: "#999999"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M444.31 262.924L446.302 270.052H443.896L441.905 262.924H444.31Z",
    fill: "#999999"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M449.87 255.083L452.716 257.929V256.211L451.588 255.083H449.87Z",
    fill: "#CCCCCC"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M443.253 267.761L443.888 270.052H445.553L443.253 267.761Z",
    fill: "#CCCCCC"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M444.311 262.924H443.553L444.601 263.973L444.311 262.924Z",
    fill: "#CCCCCC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M442.107 261.479L442.839 262.211H444.31L444.363 262.008L442.477 260.131L442.107 261.479Z",
    fill: "#CCCCCC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M447.157 256.378L447.033 256.81L452.434 262.211H452.716V261.938L447.157 256.378Z",
    fill: "#CCCCCC"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M445.306 255.083L446.09 255.85L446.205 255.427L445.861 255.083H445.306Z",
    fill: "#CCCCCC"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M445.658 261.744L445.544 262.176L445.579 262.211H446.125L445.658 261.744Z",
    fill: "#CCCCCC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M442.707 259.338L444.584 261.215L444.707 260.783L442.822 258.907L442.707 259.338Z",
    fill: "#CCCCCC"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M449.147 255.083L452.715 258.642V258.554L449.244 255.083H449.147Z",
    fill: "#CCCCCC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M445.782 261.294L445.764 261.374L446.592 262.211H446.689L445.782 261.294Z",
    fill: "#CCCCCC"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M442.927 258.546L444.804 260.422L444.83 260.343L442.945 258.466L442.927 258.546Z",
    fill: "#CCCCCC"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M441.905 262.924L441.932 263.021L445.271 266.36L445.227 266.219L441.932 262.924H441.905Z",
    fill: "#CCCCCC"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M458.654 257.461H480.821V254.166H458.654V257.461Z",
    fill: "#B3B3B3"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M458.654 257.461H480.821V254.166H458.654V257.461Z",
    fill: "#151515"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M473.34 254.158H473.649V251.823C473.649 251.303 474.01 250.88 474.451 250.88H479.649C480.089 250.88 480.451 251.303 480.451 251.823V254.158H480.759V251.823C480.759 251.127 480.265 250.563 479.649 250.563H474.451C473.843 250.563 473.34 251.127 473.34 251.823V254.158Z",
    fill: "#B3B3B3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M480.591 252.017H473.49V252.325H480.591V252.017Z",
    fill: "#B3B3B3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M480.591 253.162H473.49V253.47H480.591V253.162Z",
    fill: "#B3B3B3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M466.036 254.158H466.345V251.823C466.345 251.303 466.706 250.88 467.147 250.88H472.345C472.785 250.88 473.146 251.303 473.146 251.823V254.158H473.455V251.823C473.455 251.127 472.961 250.563 472.345 250.563H467.147C466.539 250.563 466.036 251.127 466.036 251.823V254.158Z",
    fill: "#B3B3B3"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M473.287 252.017H466.186V252.325H473.287V252.017Z",
    fill: "#B3B3B3"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M473.287 253.162H466.186V253.47H473.287V253.162Z",
    fill: "#B3B3B3"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M458.733 254.158H459.042V251.823C459.042 251.303 459.403 250.88 459.843 250.88H465.042C465.482 250.88 465.843 251.303 465.843 251.823V254.158H466.152V251.823C466.152 251.127 465.658 250.563 465.042 250.563H459.843C459.235 250.563 458.733 251.127 458.733 251.823V254.158Z",
    fill: "#B3B3B3"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M465.993 252.017H458.892V252.325H465.993V252.017Z",
    fill: "#B3B3B3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M465.993 253.162H458.892V253.47H465.993V253.162Z",
    fill: "#B3B3B3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M358.292 261.224H360.891V254.36H358.292V261.224Z",
    fill: "#B3B3B3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M350.231 261.224H352.83V254.36H350.231V261.224Z",
    fill: "#B3B3B3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M350.231 261.224H360.891V258.545H350.231V261.224Z",
    fill: "#B3B3B3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.292 261.224H360.891V254.36H358.292V261.224Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.231 261.224H352.83V254.36H350.231V261.224Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.231 261.224H360.891V258.545H350.231V261.224Z",
    fill: "#151515"
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M351.411 262.246H359.711V261.224H351.411V262.246Z",
    fill: "#B3B3B3"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M358.469 262.237H358.161V326.809H358.469V262.237Z",
    fill: "#999999"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M352.998 262.237H352.689V326.809H352.998V262.237Z",
    fill: "#999999"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M354.196 328.377V328.712L355.315 329.417H356.108L357.218 328.712V328.377H354.196Z",
    fill: "#B3B3B3"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M352.24 327.426L353.297 328.377H358.126L359.174 327.426V325.99H352.24V327.426Z",
    fill: "#B3B3B3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M353.298 328.377H358.126L359.174 327.426H352.24L353.298 328.377Z",
    fill: "#151515"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M355.403 329.417L355.456 330.597L355.712 330.342C353.597 330.544 354.285 333.945 356.329 333.099C356.813 332.905 357.06 332.377 357.025 331.883C357.069 332.941 355.712 333.434 355.042 332.712C354.478 332.13 354.831 330.8 355.712 330.861L355.959 330.879V330.606L356.02 329.425H355.403V329.417Z",
    fill: "#B3B3B3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M326.407 369.54H385.005V363.83H326.407V369.54Z",
    fill: "#B3B3B3"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M330.812 364.994L355.701 333.382L380.6 364.897L380.846 364.703L355.701 332.888L330.565 364.8L330.812 364.994Z",
    fill: "#999999"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M326.407 369.54H385.005V363.831H326.407V369.54Z",
    fill: "#B3B3B3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M343.306 363.83H368.108V339.029H343.306V363.83Z",
    fill: "#B3B3B3"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M344.539 362.597H366.874V340.262H344.539V362.597Z",
    fill: "#151515"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M364.468 362.597H365.191V340.262H364.468V362.597Z",
    fill: "#B3B3B3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.468 362.597H364.697V340.262H364.468V362.597Z",
    fill: "#151515"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M361.429 362.597H362.151V340.262H361.429V362.597Z",
    fill: "#B3B3B3"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M361.428 362.597H361.657V340.262H361.428V362.597Z",
    fill: "#151515"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M358.381 362.597H359.103V340.262H358.381V362.597Z",
    fill: "#B3B3B3"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M358.389 362.597H358.618V340.262H358.389V362.597Z",
    fill: "#151515"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M355.34 362.597H356.063V340.262H355.34V362.597Z",
    fill: "#B3B3B3"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.34 362.597H355.569V340.262H355.34V362.597Z",
    fill: "#151515"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M352.302 362.597H353.024V340.262H352.302V362.597Z",
    fill: "#B3B3B3"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M352.31 362.597H352.539V340.262H352.31V362.597Z",
    fill: "#151515"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M349.262 362.597H349.984V340.262H349.262V362.597Z",
    fill: "#B3B3B3"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M349.27 362.597H349.499V340.262H349.27V362.597Z",
    fill: "#151515"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M346.222 362.597H346.945V340.262H346.222V362.597Z",
    fill: "#B3B3B3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.222 362.597H346.451V340.262H346.222V362.597Z",
    fill: "#151515"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M448.477 197.453C448.477 198.713 449.499 199.744 450.768 199.744C452.037 199.744 453.059 198.722 453.059 197.453C453.059 196.185 452.037 195.163 450.768 195.163C449.499 195.163 448.477 196.185 448.477 197.453Z",
    fill: "#999999"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M449.851 197.453C449.851 197.956 450.257 198.361 450.759 198.361C451.261 198.361 451.666 197.956 451.666 197.453C451.666 196.951 451.261 196.546 450.759 196.546C450.257 196.546 449.851 196.951 449.851 197.453Z",
    fill: "#CCCCCC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M479.614 256.863C479.614 258.122 480.636 259.153 481.904 259.153C483.173 259.153 484.195 258.131 484.195 256.863C484.195 255.594 483.173 254.572 481.904 254.572C480.636 254.572 479.614 255.594 479.614 256.863Z",
    fill: "#999999"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M480.997 256.863C480.997 257.365 481.403 257.77 481.905 257.77C482.407 257.77 482.812 257.365 482.812 256.863C482.812 256.36 482.407 255.955 481.905 255.955C481.403 255.955 480.997 256.36 480.997 256.863Z",
    fill: "#CCCCCC"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M305.791 248.007H308.206V244.695H305.791V248.007Z",
    fill: "#B3B3B3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M306.998 249.417C307.883 249.417 308.601 248.699 308.601 247.813C308.601 246.928 307.883 246.21 306.998 246.21C306.112 246.21 305.394 246.928 305.394 247.813C305.394 248.699 306.112 249.417 306.998 249.417Z",
    fill: "#999999"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M306.998 248.448C307.348 248.448 307.632 248.164 307.632 247.814C307.632 247.463 307.348 247.179 306.998 247.179C306.647 247.179 306.363 247.463 306.363 247.814C306.363 248.164 306.647 248.448 306.998 248.448Z",
    fill: "#CCCCCC"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M480.696 292.51H483.11V289.197H480.696V292.51Z",
    fill: "#B3B3B3"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M480.299 292.315C480.299 293.196 481.013 293.919 481.903 293.919C482.792 293.919 483.506 293.205 483.506 292.315C483.506 291.426 482.792 290.712 481.903 290.712C481.013 290.712 480.299 291.426 480.299 292.315Z",
    fill: "#999999"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M481.268 292.316C481.268 292.668 481.55 292.95 481.902 292.95C482.255 292.95 482.537 292.668 482.537 292.316C482.537 291.963 482.255 291.681 481.902 291.681C481.55 291.681 481.268 291.963 481.268 292.316Z",
    fill: "#CCCCCC"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M480.3 318.086C480.3 318.967 481.013 319.69 481.903 319.69C482.793 319.69 483.507 318.976 483.507 318.086C483.507 317.197 482.793 316.483 481.903 316.483C481.013 316.483 480.3 317.197 480.3 318.086Z",
    fill: "#999999"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M481.268 318.087C481.268 318.439 481.55 318.721 481.903 318.721C482.255 318.721 482.537 318.439 482.537 318.087C482.537 317.734 482.255 317.452 481.903 317.452C481.55 317.452 481.268 317.734 481.268 318.087Z",
    fill: "#CCCCCC"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M450.768 436.552C452.433 436.552 453.781 437.9 453.781 439.565V442.578H447.755V439.565C447.755 437.9 449.103 436.552 450.768 436.552Z",
    fill: "#B3B3B3"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M450.768 439.996C451.191 439.996 451.535 439.653 451.535 439.23C451.535 438.807 451.191 438.463 450.768 438.463C450.345 438.463 450.002 438.807 450.002 439.23C450.002 439.653 450.345 439.996 450.768 439.996Z",
    fill: "#999999"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 341.02H493.005V338.456H473.877V341.02Z",
    fill: "#CCCCCC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 338.456H470.802V341.02H473.877V338.456Z",
    fill: "#999999"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 338.456H493.005V335.892H473.877V338.456Z",
    fill: "#CCCCCC"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 335.892H470.802V338.456H473.877V335.892Z",
    fill: "#999999"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M493.005 338.456C485.604 338.359 478.203 338.359 470.794 338.456C478.195 338.553 485.595 338.553 493.005 338.456Z",
    fill: "#999999"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 335.892H493.005V333.328H473.877V335.892Z",
    fill: "#CCCCCC"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 333.328H470.802V335.892H473.877V333.328Z",
    fill: "#999999"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M493.005 335.892C485.604 335.795 478.203 335.795 470.794 335.892C478.195 335.989 485.595 335.989 493.005 335.892Z",
    fill: "#999999"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 333.337H493.005V330.774H473.877V333.337Z",
    fill: "#CCCCCC"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 330.765H470.802V333.328H473.877V330.765Z",
    fill: "#999999"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M493.005 333.329C485.604 333.232 478.203 333.232 470.794 333.329C478.195 333.425 485.595 333.425 493.005 333.329Z",
    fill: "#999999"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 330.773H493.005V328.21H473.877V330.773Z",
    fill: "#CCCCCC"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 328.201H470.802V330.765H473.877V328.201Z",
    fill: "#999999"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M493.005 330.765C485.604 330.668 478.203 330.668 470.794 330.765C478.195 330.861 485.595 330.861 493.005 330.765Z",
    fill: "#999999"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 328.201H493.005V325.637H473.877V328.201Z",
    fill: "#CCCCCC"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M473.877 325.646H470.802V328.209H473.877V325.646Z",
    fill: "#999999"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M493.005 328.201C485.604 328.104 478.204 328.104 470.794 328.201C478.195 328.298 485.596 328.298 493.005 328.201Z",
    fill: "#999999"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M481.481 325.637H482.318V319.654H481.481V325.637Z",
    fill: "#B3B3B3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M234.145 453.195H236.065L236.065 249.409H234.145L234.145 453.195Z",
    fill: "#999999"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M232.223 453.195H234.144L234.144 249.409H232.223L232.223 453.195Z",
    fill: "#CCCCCC"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M246.47 453.194H248.391L248.391 279.699H246.47L246.47 453.194Z",
    fill: "#999999"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M244.549 453.194H246.47L246.47 279.699H244.549L244.549 453.194Z",
    fill: "#CCCCCC"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M259.343 453.204H261.264V302.43H259.343V453.204Z",
    fill: "#999999"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 453.204H259.343V302.43H257.422V453.204Z",
    fill: "#CCCCCC"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M196.629 453.204H198.55L198.55 232.783H196.629L196.629 453.204Z",
    fill: "#999999"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M194.699 453.204H196.62L196.62 232.783H194.699L194.699 453.204Z",
    fill: "#CCCCCC"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M159.106 453.204H161.027L161.027 232.783H159.106L159.106 453.204Z",
    fill: "#999999"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M157.185 453.204H159.106L159.106 232.783H157.185L157.185 453.204Z",
    fill: "#CCCCCC"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M157.185 416.217H261.272V407.16H157.185V416.217Z",
    fill: "#CCCCCC"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 453.195H225.368V449.089H217.677V453.195Z",
    fill: "#CCCCCC"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M213.201 449.089H220.893V444.984H213.201V449.089Z",
    fill: "#CCCCCC"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M208.717 444.983H216.408V440.878H208.717V444.983Z",
    fill: "#CCCCCC"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M204.241 440.878H211.932V436.772H204.241V440.878Z",
    fill: "#CCCCCC"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M199.765 436.763H207.457V432.658H199.765V436.763Z",
    fill: "#CCCCCC"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M195.299 432.658H202.99V428.552H195.299V432.658Z",
    fill: "#CCCCCC"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M190.813 428.552H198.505V424.446H190.813V428.552Z",
    fill: "#CCCCCC"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M186.338 424.438H194.029V420.332H186.338V424.438Z",
    fill: "#CCCCCC"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M181.863 420.332H189.554V416.226H181.863V420.332Z",
    fill: "#CCCCCC"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 453.195L181.862 420.332H186.338L222.602 453.195H217.677Z",
    fill: "#CCCCCC"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M157.185 370.191H261.272V361.134H157.185V370.191Z",
    fill: "#CCCCCC"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 407.168H225.368V403.063H217.677V407.168Z",
    fill: "#CCCCCC"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M213.201 403.054H220.893V398.949H213.201V403.054Z",
    fill: "#CCCCCC"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M208.717 398.948H216.408V394.843H208.717V398.948Z",
    fill: "#CCCCCC"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M204.241 394.843H211.932V390.737H204.241V394.843Z",
    fill: "#CCCCCC"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M199.765 390.728H207.457V386.622H199.765V390.728Z",
    fill: "#CCCCCC"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M195.299 386.623H202.99V382.517H195.299V386.623Z",
    fill: "#CCCCCC"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M190.813 382.508H198.505V378.402H190.813V382.508Z",
    fill: "#CCCCCC"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M186.338 378.411H194.029V374.305H186.338V378.411Z",
    fill: "#CCCCCC"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M181.863 374.296H189.554V370.191H181.863V374.296Z",
    fill: "#CCCCCC"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 407.168L181.862 374.296H186.338L222.602 407.168H217.677Z",
    fill: "#CCCCCC"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M157.185 324.157H261.272V315.1H157.185V324.157Z",
    fill: "#CCCCCC"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 361.134H225.368V357.028H217.677V361.134Z",
    fill: "#CCCCCC"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M213.201 357.028H220.893V352.923H213.201V357.028Z",
    fill: "#CCCCCC"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M208.717 352.914H216.408V348.808H208.717V352.914Z",
    fill: "#CCCCCC"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M204.241 348.799H211.932V344.694H204.241V348.799Z",
    fill: "#CCCCCC"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M199.765 344.702H207.457V340.596H199.765V344.702Z",
    fill: "#CCCCCC"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M195.299 340.588H202.99V336.482H195.299V340.588Z",
    fill: "#CCCCCC"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M190.813 336.482H198.505V332.376H190.813V336.482Z",
    fill: "#CCCCCC"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M186.338 332.376H194.029V328.271H186.338V332.376Z",
    fill: "#CCCCCC"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M181.863 328.271H189.554V324.165H181.863V328.271Z",
    fill: "#CCCCCC"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 361.134L181.862 328.262H186.338L222.602 361.134H217.677Z",
    fill: "#CCCCCC"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M157.176 278.122H232.215V269.065H157.176V278.122Z",
    fill: "#CCCCCC"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 315.099H225.368V310.993H217.677V315.099Z",
    fill: "#CCCCCC"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M213.201 310.994H220.893V306.888H213.201V310.994Z",
    fill: "#CCCCCC"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M208.717 306.879H216.408V302.773H208.717V306.879Z",
    fill: "#CCCCCC"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M204.241 302.773H211.932V298.668H204.241V302.773Z",
    fill: "#CCCCCC"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M199.765 298.667H207.457V294.562H199.765V298.667Z",
    fill: "#CCCCCC"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M195.299 294.562H202.99V290.456H195.299V294.562Z",
    fill: "#CCCCCC"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M190.813 290.447H198.505V286.342H190.813V290.447Z",
    fill: "#CCCCCC"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M186.338 286.342H194.029V282.236H186.338V286.342Z",
    fill: "#CCCCCC"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M181.863 282.236H189.554V278.13H181.863V282.236Z",
    fill: "#CCCCCC"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M217.677 315.099L181.862 282.236H186.338L222.602 315.099H217.677Z",
    fill: "#CCCCCC"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M368.427 453.204H447.404V372.834H368.427V453.204Z",
    fill: "#999999"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M289.45 453.195H368.427V325.857H289.45V453.195Z",
    fill: "#999999"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M289.441 325.866H259.248V453.203H289.441V325.866Z",
    fill: "#999999"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 343.055H359.061V336.342H343.511V343.055Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 357.39H359.061V350.676H343.511V357.39Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 371.733H359.061V365.02H343.511V371.733Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 386.085H359.061V379.372H343.511V386.085Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 400.429H359.061V393.715H343.511V400.429Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 414.772H359.061V408.058H343.511V414.772Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M343.511 429.116H359.061V422.402H343.511V429.116Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 343.055H336.682V336.342H321.132V343.055Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 357.39H336.682V350.676H321.132V357.39Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 371.733H336.682V365.02H321.132V371.733Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 386.085H336.682V379.372H321.132V386.085Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 400.429H336.682V393.715H321.132V400.429Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 414.772H336.682V408.058H321.132V414.772Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M321.132 429.116H336.682V422.402H321.132V429.116Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 343.055H314.357V336.342H298.806V343.055Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 357.39H314.357V350.676H298.806V357.39Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 371.733H314.357V365.02H298.806V371.733Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 386.085H314.357V379.372H298.806V386.085Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 400.429H314.357V393.715H298.806V400.429Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 414.772H314.357V408.058H298.806V414.772Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M298.806 429.116H314.357V422.402H298.806V429.116Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M422.479 386.085H438.03V379.372H422.479V386.085Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M422.479 400.429H438.03V393.715H422.479V400.429Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M422.479 414.772H438.03V408.058H422.479V414.772Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M422.479 429.116H438.03V422.402H422.479V429.116Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M400.118 386.085H415.669V379.372H400.118V386.085Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M400.118 400.429H415.669V393.715H400.118V400.429Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M400.118 414.772H415.669V408.058H400.118V414.772Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M400.118 429.116H415.669V422.402H400.118V429.116Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M377.793 386.085H393.343V379.372H377.793V386.085Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M377.793 400.429H393.343V393.715H377.793V400.429Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M377.793 414.772H393.343V408.058H377.793V414.772Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M377.793 429.116H393.343V422.402H377.793V429.116Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 343.055H282.128V336.342H266.578V343.055Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 357.39H282.128V350.676H266.578V357.39Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 371.733H282.128V365.02H266.578V371.733Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 386.085H282.128V379.372H266.578V386.085Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 400.429H282.128V393.715H266.578V400.429Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 414.772H282.128V408.058H266.578V414.772Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 429.116H282.128V422.402H266.578V429.116Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M327.529 288.457H324.727V325.866H327.529V288.457Z",
    fill: "#A6A6A6"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M330.331 288.457H327.529V325.866H330.331V288.457Z",
    fill: "#C7C7C7"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M289.441 288.457H286.639V325.866H289.441V288.457Z",
    fill: "#A6A6A6"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M292.242 288.457H289.441V325.866H292.242V288.457Z",
    fill: "#C7C7C7"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M365.616 288.457H362.814V325.866H365.616V288.457Z",
    fill: "#A6A6A6"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M368.417 288.457H365.615V325.866H368.417V288.457Z",
    fill: "#C7C7C7"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M406.506 335.337H403.704V372.746H406.506V335.337Z",
    fill: "#A6A6A6"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M409.317 335.337H406.515V372.746H409.317V335.337Z",
    fill: "#C7C7C7"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M444.603 335.337H441.801V372.746H444.603V335.337Z",
    fill: "#A6A6A6"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M447.404 335.337H444.603V372.746H447.404V335.337Z",
    fill: "#C7C7C7"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M262.049 288.457H259.248V325.866H262.049V288.457Z",
    fill: "#A6A6A6"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M264.86 288.457H262.058V325.866H264.86V288.457Z",
    fill: "#C7C7C7"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M167.707 383.424V279.796L169.504 277.417L166.694 161.788L212.905 73.5954L218.975 71.5073L429.695 145.982",
    stroke: "#151515",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M172.455 383.425V279.796L170.667 277.417L173.477 161.788L216.305 76.3091",
    stroke: "#151515",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M243.794 437.433H159.645V444.059H243.794V437.433Z",
    fill: "#C7C7C7"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M248.789 444.059H154.667V453.195H248.789V444.059Z",
    fill: "#A6A6A6"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M214.967 182.705H214.183V437.442H214.967V182.705Z",
    fill: "#FFC727"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M218.421 182.705H217.637V437.442H218.421V182.705Z",
    fill: "#FFC727"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 435.997V435.213H214.967V435.997H217.628Z",
    fill: "#FFC727"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 433.389V432.604H214.976V433.389H217.637Z",
    fill: "#FFC727"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 430.781V429.997H214.976V430.781H217.637Z",
    fill: "#FFC727"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 428.165V427.38H214.976V428.165H217.637Z",
    fill: "#FFC727"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 425.557V424.772H214.976V425.557H217.637Z",
    fill: "#FFC727"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 422.949V422.165H214.976V422.949H217.637Z",
    fill: "#FFC727"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 420.341V419.557H214.976V420.341H217.637Z",
    fill: "#FFC727"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 417.733V416.949H214.976V417.733H217.637Z",
    fill: "#FFC727"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 415.125V414.341H214.967V415.125H217.628Z",
    fill: "#FFC727"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 412.517V411.733H214.976V412.517H217.637Z",
    fill: "#FFC727"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 409.909V409.125H214.976V409.909H217.637Z",
    fill: "#FFC727"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 407.292V406.508H214.976V407.292H217.637Z",
    fill: "#FFC727"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 404.685V403.9H214.976V404.685H217.637Z",
    fill: "#FFC727"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 402.077V401.292H214.976V402.077H217.637Z",
    fill: "#FFC727"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 399.469V398.685H214.976V399.469H217.637Z",
    fill: "#FFC727"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 396.861V396.077H214.967V396.861H217.628Z",
    fill: "#FFC727"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 394.253V393.469H214.976V394.253H217.637Z",
    fill: "#FFC727"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 391.645V390.861H214.976V391.645H217.637Z",
    fill: "#FFC727"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 389.028V388.244H214.976V389.028H217.637Z",
    fill: "#FFC727"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 386.42V385.636H214.976V386.42H217.637Z",
    fill: "#FFC727"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 383.812V383.028H214.976V383.812H217.637Z",
    fill: "#FFC727"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 381.205V380.42H214.976V381.205H217.637Z",
    fill: "#FFC727"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 378.597V377.812H214.976V378.597H217.637Z",
    fill: "#FFC727"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 375.989V375.205H214.976V375.989H217.637Z",
    fill: "#FFC727"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 373.381V372.597H214.976V373.381H217.637Z",
    fill: "#FFC727"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 370.773V369.989H214.976V370.773H217.637Z",
    fill: "#FFC727"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 368.156V367.372H214.976V368.156H217.637Z",
    fill: "#FFC727"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 365.548V364.764H214.976V365.548H217.637Z",
    fill: "#FFC727"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 362.94V362.156H214.976V362.94H217.637Z",
    fill: "#FFC727"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 360.332V359.548H214.976V360.332H217.637Z",
    fill: "#FFC727"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 357.725V356.94H214.967V357.725H217.628Z",
    fill: "#FFC727"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 355.117V354.333H214.976V355.117H217.637Z",
    fill: "#FFC727"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 352.509V351.725H214.976V352.509H217.637Z",
    fill: "#FFC727"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 349.892V349.108H214.976V349.892H217.637Z",
    fill: "#FFC727"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 347.284V346.5H214.976V347.284H217.637Z",
    fill: "#FFC727"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 344.676V343.892H214.976V344.676H217.637Z",
    fill: "#FFC727"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 342.068V341.284H214.976V342.068H217.637Z",
    fill: "#FFC727"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 339.46V338.676H214.976V339.46H217.637Z",
    fill: "#FFC727"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 336.852V336.068H214.976V336.852H217.637Z",
    fill: "#FFC727"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 334.245V333.46H214.976V334.245H217.637Z",
    fill: "#FFC727"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 331.637V330.853H214.976V331.637H217.637Z",
    fill: "#FFC727"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 329.02V328.236H214.976V329.02H217.637Z",
    fill: "#FFC727"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 326.412V325.628H214.976V326.412H217.637Z",
    fill: "#FFC727"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 323.804V323.02H214.976V323.804H217.637Z",
    fill: "#FFC727"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 321.196V320.412H214.976V321.196H217.637Z",
    fill: "#FFC727"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 318.588V317.804H214.967V318.588H217.628Z",
    fill: "#FFC727"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 315.98V315.196H214.976V315.98H217.637Z",
    fill: "#FFC727"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 313.373V312.588H214.976V313.373H217.637Z",
    fill: "#FFC727"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 310.756V309.972H214.976V310.756H217.637Z",
    fill: "#FFC727"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 308.148V307.364H214.976V308.148H217.637Z",
    fill: "#FFC727"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 305.54V304.756H214.976V305.54H217.637Z",
    fill: "#FFC727"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 302.933V302.148H214.976V302.933H217.637Z",
    fill: "#FFC727"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 300.324V299.54H214.976V300.324H217.637Z",
    fill: "#FFC727"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 297.716V296.932H214.976V297.716H217.637Z",
    fill: "#FFC727"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 295.108V294.324H214.976V295.108H217.637Z",
    fill: "#FFC727"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 292.5V291.716H214.976V292.5H217.637Z",
    fill: "#FFC727"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 289.884V289.1H214.976V289.884H217.637Z",
    fill: "#FFC727"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 287.276V286.492H214.976V287.276H217.637Z",
    fill: "#FFC727"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 284.668V283.884H214.976V284.668H217.637Z",
    fill: "#FFC727"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 282.06V281.276H214.976V282.06H217.637Z",
    fill: "#FFC727"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 279.452V278.668H214.967V279.452H217.628Z",
    fill: "#FFC727"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 276.845V276.061H214.976V276.845H217.637Z",
    fill: "#FFC727"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 274.237V273.453H214.976V274.237H217.637Z",
    fill: "#FFC727"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 271.62V270.836H214.976V271.62H217.637Z",
    fill: "#FFC727"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 269.012V268.228H214.976V269.012H217.637Z",
    fill: "#FFC727"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 266.404V265.62H214.976V266.404H217.637Z",
    fill: "#FFC727"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 263.796V263.012H214.976V263.796H217.637Z",
    fill: "#FFC727"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 261.188V260.404H214.967V261.188H217.628Z",
    fill: "#FFC727"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 258.581V257.796H214.976V258.581H217.637Z",
    fill: "#FFC727"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 255.973V255.188H214.976V255.973H217.637Z",
    fill: "#FFC727"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 253.356V252.572H214.976V253.356H217.637Z",
    fill: "#FFC727"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 250.748V249.964H214.976V250.748H217.637Z",
    fill: "#FFC727"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 248.14V247.356H214.976V248.14H217.637Z",
    fill: "#FFC727"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 245.532V244.748H214.976V245.532H217.637Z",
    fill: "#FFC727"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 242.924V242.14H214.976V242.924H217.637Z",
    fill: "#FFC727"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 240.316V239.532H214.967V240.316H217.628Z",
    fill: "#FFC727"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 237.708V236.924H214.976V237.708H217.637Z",
    fill: "#FFC727"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 235.101V234.316H214.976V235.101H217.637Z",
    fill: "#FFC727"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 232.484V231.7H214.976V232.484H217.637Z",
    fill: "#FFC727"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 229.876V229.092H214.976V229.876H217.637Z",
    fill: "#FFC727"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 227.268V226.484H214.976V227.268H217.637Z",
    fill: "#FFC727"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 224.66V223.876H214.976V224.66H217.637Z",
    fill: "#FFC727"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M217.628 222.052V221.268H214.967V222.052H217.628Z",
    fill: "#FFC727"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 219.444V218.66H214.976V219.444H217.637Z",
    fill: "#FFC727"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 216.836V216.052H214.976V216.836H217.637Z",
    fill: "#FFC727"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 214.22V213.436H214.976V214.22H217.637Z",
    fill: "#FFC727"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 211.612V210.828H214.976V211.612H217.637Z",
    fill: "#FFC727"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 209.004V208.22H214.976V209.004H217.637Z",
    fill: "#FFC727"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 206.396V205.612H214.976V206.396H217.637Z",
    fill: "#FFC727"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 203.788V203.004H214.976V203.788H217.637Z",
    fill: "#FFC727"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 201.18V200.396H214.976V201.18H217.637Z",
    fill: "#FFC727"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 198.572V197.788H214.976V198.572H217.637Z",
    fill: "#FFC727"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 195.964V195.18H214.976V195.964H217.637Z",
    fill: "#FFC727"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 193.348V192.563H214.976V193.348H217.637Z",
    fill: "#FFC727"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 190.74V189.956H214.976V190.74H217.637Z",
    fill: "#FFC727"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 188.132V187.348H214.976V188.132H217.637Z",
    fill: "#FFC727"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M217.637 185.524V184.74H214.976V185.524H217.637Z",
    fill: "#FFC727"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.967 182.705H214.183V437.442H214.967V182.705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.421 182.705H217.637V437.442H218.421V182.705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 435.997V435.213H214.967V435.997H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 433.389V432.604H214.976V433.389H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 430.781V429.997H214.976V430.781H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 428.165V427.38H214.976V428.165H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 425.557V424.772H214.976V425.557H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 422.949V422.165H214.976V422.949H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 420.341V419.557H214.976V420.341H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 417.733V416.949H214.976V417.733H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 415.125V414.341H214.967V415.125H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 412.517V411.733H214.976V412.517H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 409.909V409.125H214.976V409.909H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 407.292V406.508H214.976V407.292H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 404.685V403.9H214.976V404.685H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 402.077V401.292H214.976V402.077H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 399.469V398.685H214.976V399.469H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 396.861V396.077H214.967V396.861H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 394.253V393.469H214.976V394.253H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 391.645V390.861H214.976V391.645H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 389.028V388.244H214.976V389.028H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 386.42V385.636H214.976V386.42H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 383.812V383.028H214.976V383.812H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 381.205V380.42H214.976V381.205H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 378.597V377.812H214.976V378.597H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 375.989V375.205H214.976V375.989H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 373.381V372.597H214.976V373.381H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 370.773V369.989H214.976V370.773H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 368.156V367.372H214.976V368.156H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 365.548V364.764H214.976V365.548H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 362.94V362.156H214.976V362.94H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 360.332V359.548H214.976V360.332H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 357.725V356.94H214.967V357.725H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 355.117V354.333H214.976V355.117H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 352.509V351.725H214.976V352.509H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 349.892V349.108H214.976V349.892H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 347.284V346.5H214.976V347.284H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 344.676V343.892H214.976V344.676H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 342.068V341.284H214.976V342.068H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 339.46V338.676H214.976V339.46H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 336.852V336.068H214.976V336.852H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 334.245V333.46H214.976V334.245H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 331.637V330.853H214.976V331.637H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 329.02V328.236H214.976V329.02H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 326.412V325.628H214.976V326.412H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 323.804V323.02H214.976V323.804H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 321.196V320.412H214.976V321.196H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 318.588V317.804H214.967V318.588H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 315.98V315.196H214.976V315.98H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 313.373V312.588H214.976V313.373H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 310.756V309.972H214.976V310.756H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 308.148V307.364H214.976V308.148H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 305.54V304.756H214.976V305.54H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 302.933V302.148H214.976V302.933H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 300.324V299.54H214.976V300.324H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 297.716V296.932H214.976V297.716H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 295.108V294.324H214.976V295.108H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 292.5V291.716H214.976V292.5H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 289.884V289.1H214.976V289.884H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 287.276V286.492H214.976V287.276H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 284.668V283.884H214.976V284.668H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 282.06V281.276H214.976V282.06H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 279.452V278.668H214.967V279.452H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 276.845V276.061H214.976V276.845H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 274.237V273.453H214.976V274.237H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 271.62V270.836H214.976V271.62H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 269.012V268.228H214.976V269.012H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 266.404V265.62H214.976V266.404H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 263.796V263.012H214.976V263.796H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 261.188V260.404H214.967V261.188H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 258.581V257.796H214.976V258.581H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 255.973V255.188H214.976V255.973H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 253.356V252.572H214.976V253.356H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 250.748V249.964H214.976V250.748H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 248.14V247.356H214.976V248.14H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 245.532V244.748H214.976V245.532H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 242.924V242.14H214.976V242.924H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 240.316V239.532H214.967V240.316H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 237.708V236.924H214.976V237.708H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 235.101V234.316H214.976V235.101H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 232.484V231.7H214.976V232.484H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 229.876V229.092H214.976V229.876H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 227.268V226.484H214.976V227.268H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 224.66V223.876H214.976V224.66H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.628 222.052V221.268H214.967V222.052H217.628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 219.444V218.66H214.976V219.444H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 216.836V216.052H214.976V216.836H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 214.22V213.436H214.976V214.22H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 211.612V210.828H214.976V211.612H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 209.004V208.22H214.976V209.004H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 206.396V205.612H214.976V206.396H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 203.788V203.004H214.976V203.788H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 201.18V200.396H214.976V201.18H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 198.572V197.788H214.976V198.572H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 195.964V195.18H214.976V195.964H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 193.348V192.563H214.976V193.348H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 190.74V189.956H214.976V190.74H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 188.132V187.348H214.976V188.132H217.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.637 185.524V184.74H214.976V185.524H217.637Z",
    fill: "black"
  }))), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M224.587 342.844V374.147L218.957 432.464H213.653L208.024 374.147V342.844H224.587Z",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M208.023 374.147H224.587",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M208.024 342.844L216.305 371.169L224.587 342.844",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M221.768 403.31L216.305 374.984L210.808 403.31",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M216.306 374.147V432.464",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M221.389 433.151H219.098L223.891 374.095V342.157H228.164V374.148L221.38 433.151H221.389ZM225.274 343.54V374.156L221.627 419.09L226.807 374.077V343.54H225.274Z",
    fill: "#FFC727"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M227.486 373.469H224.588V374.844H227.486V373.469Z",
    fill: "#FFC727"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M226.719 371.205H225.345L223.9 342.879L225.266 342.817L226.032 357.725L226.799 342.817L228.173 342.879L226.719 371.205Z",
    fill: "#FFC727"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M225.346 374.078L219.628 432.388L220.996 432.522L226.713 374.212L225.346 374.078Z",
    fill: "#FFC727"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.389 433.151H219.098L223.891 374.095V342.157H228.164V374.148L221.38 433.151H221.389ZM225.274 343.54V374.156L221.627 419.09L226.807 374.077V343.54H225.274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.486 373.469H224.588V374.844H227.486V373.469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.719 371.205H225.345L223.9 342.879L225.266 342.817L226.032 357.725L226.799 342.817L228.173 342.879L226.719 371.205Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.346 374.078L219.628 432.388L220.996 432.522L226.713 374.212L225.346 374.078Z",
    fill: "black"
  }))), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M208.024 158.238V129.621L214.993 76.3091H217.609L224.587 129.621V158.238H208.024Z",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M224.587 129.621H208.023",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M224.587 158.238L216.305 132.344L208.023 158.238",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M211.512 102.96L216.305 128.863L221.107 103.04",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M216.306 129.621V76.3091",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 182.705H209.68V342.853H222.931V182.705Z",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 342.844L209.68 334.421L222.931 325.989",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 325.989L209.68 317.558L222.931 309.135",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 325.989H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 309.135L209.68 300.704L222.931 292.272",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 309.135H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 292.272L209.68 283.849L222.931 275.417",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 292.272H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 275.417L209.68 266.986L222.931 258.563",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 275.417H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 258.563L209.68 250.131L222.931 241.7",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 258.563H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 241.7L209.68 233.277L222.931 224.845",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 241.7H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 224.845L209.68 216.414L222.931 207.991",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 224.845H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 207.991L209.68 199.559L222.931 191.127",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 207.991H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M222.931 191.127L209.68 182.705",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M209.883 191.127H222.931",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M226.922 343.539H222.243V182.017H226.922V343.539ZM223.618 342.156H225.547V183.383H223.618V342.156Z",
    fill: "#FFC727"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 342.976L222.613 342.72L225.864 334.421L222.613 326.112L223.247 325.866L226.604 334.421L223.247 342.976Z",
    fill: "#FFC727"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 326.112L222.613 325.866L225.864 317.557L222.613 309.258L223.247 309.011L226.604 317.557L223.247 326.112Z",
    fill: "#FFC727"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 325.302H222.931V326.676H226.182V325.302Z",
    fill: "#FFC727"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 309.258L222.613 309.011L225.864 300.703L222.613 292.403L223.247 292.148L226.604 300.703L223.247 309.258Z",
    fill: "#FFC727"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 308.447H222.931V309.822H226.182V308.447Z",
    fill: "#FFC727"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 292.403L222.613 292.148L225.864 283.848L222.613 275.54L223.247 275.293L226.604 283.848L223.247 292.403Z",
    fill: "#FFC727"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 291.584H222.931V292.958H226.182V291.584Z",
    fill: "#FFC727"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 275.54L222.613 275.293L225.864 266.985L222.613 258.686L223.247 258.43L226.604 266.985L223.247 275.54Z",
    fill: "#FFC727"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 274.729H222.931V276.104H226.182V274.729Z",
    fill: "#FFC727"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 258.686L222.613 258.43L225.864 250.131L222.613 241.831L223.247 241.576L226.604 250.131L223.247 258.686Z",
    fill: "#FFC727"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 257.875H222.931V259.249H226.182V257.875Z",
    fill: "#FFC727"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 241.831L222.613 241.576L225.864 233.276L222.613 224.968L223.247 224.721L226.604 233.276L223.247 241.831Z",
    fill: "#FFC727"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 241.012H222.931V242.386H226.182V241.012Z",
    fill: "#FFC727"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 224.968L222.613 224.722L225.864 216.413L222.613 208.114L223.247 207.867L226.604 216.413L223.247 224.968Z",
    fill: "#FFC727"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 224.158H222.931V225.532H226.182V224.158Z",
    fill: "#FFC727"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M223.247 208.113L222.613 207.867L225.864 199.558L222.613 191.259L223.247 191.003L226.604 199.558L223.247 208.113Z",
    fill: "#FFC727"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 207.303H222.931V208.678H226.182V207.303Z",
    fill: "#FFC727"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M225.917 182.571L222.614 191.004L223.254 191.255L226.557 182.822L225.917 182.571Z",
    fill: "#FFC727"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M226.182 190.44H222.931V191.814H226.182V190.44Z",
    fill: "#FFC727"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.922 343.539H222.243V182.017H226.922V343.539ZM223.618 342.156H225.547V183.383H223.618V342.156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 342.976L222.613 342.72L225.864 334.421L222.613 326.112L223.247 325.866L226.604 334.421L223.247 342.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 326.112L222.613 325.866L225.864 317.557L222.613 309.258L223.247 309.011L226.604 317.557L223.247 326.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 325.302H222.931V326.676H226.182V325.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 309.258L222.613 309.011L225.864 300.703L222.613 292.403L223.247 292.148L226.604 300.703L223.247 309.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 308.447H222.931V309.822H226.182V308.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 292.403L222.613 292.148L225.864 283.848L222.613 275.54L223.247 275.293L226.604 283.848L223.247 292.403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 291.584H222.931V292.958H226.182V291.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 275.54L222.613 275.293L225.864 266.985L222.613 258.686L223.247 258.43L226.604 266.985L223.247 275.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 274.729H222.931V276.104H226.182V274.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 258.686L222.613 258.43L225.864 250.131L222.613 241.831L223.247 241.576L226.604 250.131L223.247 258.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 257.875H222.931V259.249H226.182V257.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 241.831L222.613 241.576L225.864 233.276L222.613 224.968L223.247 224.721L226.604 233.276L223.247 241.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 241.012H222.931V242.386H226.182V241.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 224.968L222.613 224.722L225.864 216.413L222.613 208.114L223.247 207.867L226.604 216.413L223.247 224.968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 224.158H222.931V225.532H226.182V224.158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.247 208.113L222.613 207.867L225.864 199.558L222.613 191.259L223.247 191.003L226.604 199.558L223.247 208.113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 207.303H222.931V208.678H226.182V207.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.917 182.571L222.614 191.004L223.254 191.255L226.557 182.822L225.917 182.571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.182 190.44H222.931V191.814H226.182V190.44Z",
    fill: "black"
  }))), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M486.153 158.238H224.729V147.207H478.779L485.704 157.559L486.153 158.238Z",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M309.151 147.207L300.719 158.238L292.288 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M292.288 147.207L283.865 158.238L275.433 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M292.288 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M326.006 147.207L317.574 158.238L309.152 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M309.152 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M342.86 147.207L334.437 158.238L326.006 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M326.006 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M359.723 147.207L351.292 158.238L342.86 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M342.86 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M376.578 147.207L368.146 158.238L359.723 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M359.723 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M393.441 147.207L385.009 158.238L376.578 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M376.578 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M410.296 147.207L401.864 158.238L393.441 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M393.441 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M427.15 147.207L418.727 158.238L410.296 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M410.296 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M444.013 147.207L435.582 158.238L427.15 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M427.15 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M460.867 147.207L452.436 158.238L444.013 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M444.013 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M477.722 147.207L469.299 158.238L460.867 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M460.867 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M486.154 158.238L477.722 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M477.722 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M275.434 147.207L267.002 158.238L258.579 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M275.433 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M258.579 147.207L250.148 158.238L241.716 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M258.579 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M241.716 147.207L233.293 158.238L224.862 147.207",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M241.716 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M224.862 147.207L224.729 147.383",
    stroke: "#FFC727",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M224.862 158.07V147.207",
    stroke: "#FFC727",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M224.729 157.559V158.934H481.334L478.612 160.828H478.603L478.409 160.969L478.233 161.092H224.729V162.467H478.665L484.726 158.238L485.66 157.586L485.704 157.55H224.729V157.559ZM233.293 158.616L232.527 158.934H234.051L233.284 158.616H233.293ZM250.148 158.616L249.381 158.934H250.905L250.139 158.616H250.148ZM267.002 158.616L266.235 158.934H267.76L266.993 158.616H267.002ZM283.856 158.616L283.09 158.934H284.614L283.848 158.616H283.856ZM300.72 158.616L299.953 158.934H301.477L300.711 158.616H300.72ZM317.574 158.616L316.808 158.934H318.332L317.565 158.616H317.574ZM334.437 158.616L333.671 158.934H335.195L334.429 158.616H334.437ZM351.301 158.616L350.534 158.934H352.058L351.292 158.616H351.301ZM368.146 158.616L367.38 158.934H368.904L368.137 158.616H368.146ZM385.009 158.616L384.243 158.934H385.767L385.001 158.616H385.009ZM401.864 158.616L401.097 158.934H402.622L401.855 158.616H401.864ZM418.727 158.616L417.961 158.934H419.485L418.718 158.616H418.727ZM435.582 158.616L434.815 158.934H436.339L435.573 158.616H435.582ZM452.445 158.616L451.678 158.934H453.202L452.436 158.616H452.445ZM469.29 158.616L468.524 158.934H470.048L469.282 158.616H469.29Z",
    fill: "#FFC727"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M309.02 162.106L300.72 158.617L292.43 162.106L292.156 161.471L300.72 157.868L309.284 161.471L309.02 162.106Z",
    fill: "#FFC727"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M292.157 162.106L283.866 158.617L275.566 162.106L275.302 161.471L283.866 157.868L292.43 161.471L292.157 162.106Z",
    fill: "#FFC727"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M292.976 158.299H291.602V161.788H292.976V158.299Z",
    fill: "#FFC727"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M325.874 162.106L317.574 158.617L309.284 162.106L309.019 161.471L317.574 157.868L326.138 161.471L325.874 162.106Z",
    fill: "#FFC727"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M309.839 158.299H308.464V161.788H309.839V158.299Z",
    fill: "#FFC727"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M326.138 162.106L325.874 161.471L334.438 157.868L343.001 161.471L342.728 162.106L334.438 158.617L326.138 162.106Z",
    fill: "#FFC727"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M326.693 158.299H325.319V161.788H326.693V158.299Z",
    fill: "#FFC727"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M359.591 162.106L351.292 158.617L343.001 162.106L342.728 161.471L351.292 157.868L359.856 161.471L359.591 162.106Z",
    fill: "#FFC727"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M343.548 158.299H342.173V161.788H343.548V158.299Z",
    fill: "#FFC727"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M376.446 162.106L368.156 158.617L359.856 162.106L359.592 161.471L368.156 157.868L376.711 161.471L376.446 162.106Z",
    fill: "#FFC727"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M360.411 158.299H359.037V161.788H360.411V158.299Z",
    fill: "#FFC727"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M393.301 162.106L385.01 158.617L376.71 162.106L376.446 161.471L385.01 157.868L393.574 161.471L393.301 162.106Z",
    fill: "#FFC727"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M377.266 158.299H375.891V161.788H377.266V158.299Z",
    fill: "#FFC727"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M410.164 162.106L401.864 158.617L393.574 162.106L393.301 161.471L401.864 157.868L410.428 161.471L410.164 162.106Z",
    fill: "#FFC727"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M394.12 158.299H392.746V161.788H394.12V158.299Z",
    fill: "#FFC727"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M427.018 162.106L418.727 158.617L410.428 162.106L410.163 161.471L418.727 157.868L427.282 161.471L427.018 162.106Z",
    fill: "#FFC727"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M410.983 158.299H409.609V161.788H410.983V158.299Z",
    fill: "#FFC727"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M443.872 162.106L435.582 158.617L427.282 162.106L427.018 161.471L435.582 157.868L444.145 161.471L443.872 162.106Z",
    fill: "#FFC727"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M427.837 158.299H426.463V161.788H427.837V158.299Z",
    fill: "#FFC727"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M460.735 162.106L452.436 158.617L444.145 162.106L443.872 161.471L452.436 157.868L461 161.471L460.735 162.106Z",
    fill: "#FFC727"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M444.692 158.299H443.317V161.788H444.692V158.299Z",
    fill: "#FFC727"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M477.59 162.106L469.3 158.617L461 162.106L460.736 161.471L469.3 157.868L477.855 161.471L477.59 162.106Z",
    fill: "#FFC727"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M461.555 158.299H460.181V161.788H461.555V158.299Z",
    fill: "#FFC727"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M483.353 157.974L477.556 161.514L477.914 162.1L483.711 158.56L483.353 157.974Z",
    fill: "#FFC727"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M478.41 158.299H477.035V161.788H478.41V158.299Z",
    fill: "#FFC727"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M275.301 162.106L267.002 158.617L258.711 162.106L258.447 161.471L267.002 157.868L275.566 161.471L275.301 162.106Z",
    fill: "#FFC727"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M276.121 158.299H274.746V161.788H276.121V158.299Z",
    fill: "#FFC727"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M258.447 162.106L250.148 158.617L241.857 162.106L241.584 161.471L250.148 157.868L258.712 161.471L258.447 162.106Z",
    fill: "#FFC727"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M259.267 158.299H257.892V161.788H259.267V158.299Z",
    fill: "#FFC727"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M241.584 162.106L233.294 158.617L224.994 162.106L224.73 161.471L233.294 157.868L241.857 161.471L241.584 162.106Z",
    fill: "#FFC727"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M242.403 158.299H241.029V161.788H242.403V158.299Z",
    fill: "#FFC727"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M225.003 161.471L224.862 161.788L224.73 162.097V161.356L224.862 161.418L225.003 161.471Z",
    fill: "#FFC727"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M225.549 158.291H224.73V161.788H225.549V158.291Z",
    fill: "#FFC727"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.729 157.559V158.934H481.334L478.612 160.828H478.603L478.409 160.969L478.233 161.092H224.729V162.467H478.665L484.726 158.238L485.66 157.586L485.704 157.55H224.729V157.559ZM233.293 158.616L232.527 158.934H234.051L233.284 158.616H233.293ZM250.148 158.616L249.381 158.934H250.905L250.139 158.616H250.148ZM267.002 158.616L266.235 158.934H267.76L266.993 158.616H267.002ZM283.856 158.616L283.09 158.934H284.614L283.848 158.616H283.856ZM300.72 158.616L299.953 158.934H301.477L300.711 158.616H300.72ZM317.574 158.616L316.808 158.934H318.332L317.565 158.616H317.574ZM334.437 158.616L333.671 158.934H335.195L334.429 158.616H334.437ZM351.301 158.616L350.534 158.934H352.058L351.292 158.616H351.301ZM368.146 158.616L367.38 158.934H368.904L368.137 158.616H368.146ZM385.009 158.616L384.243 158.934H385.767L385.001 158.616H385.009ZM401.864 158.616L401.097 158.934H402.622L401.855 158.616H401.864ZM418.727 158.616L417.961 158.934H419.485L418.718 158.616H418.727ZM435.582 158.616L434.815 158.934H436.339L435.573 158.616H435.582ZM452.445 158.616L451.678 158.934H453.202L452.436 158.616H452.445ZM469.29 158.616L468.524 158.934H470.048L469.282 158.616H469.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.02 162.106L300.72 158.617L292.43 162.106L292.156 161.471L300.72 157.868L309.284 161.471L309.02 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.157 162.106L283.866 158.617L275.566 162.106L275.302 161.471L283.866 157.868L292.43 161.471L292.157 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.976 158.299H291.602V161.788H292.976V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.874 162.106L317.574 158.617L309.284 162.106L309.019 161.471L317.574 157.868L326.138 161.471L325.874 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.839 158.299H308.464V161.788H309.839V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.138 162.106L325.874 161.471L334.438 157.868L343.001 161.471L342.728 162.106L334.438 158.617L326.138 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.693 158.299H325.319V161.788H326.693V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.591 162.106L351.292 158.617L343.001 162.106L342.728 161.471L351.292 157.868L359.856 161.471L359.591 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.548 158.299H342.173V161.788H343.548V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.446 162.106L368.156 158.617L359.856 162.106L359.592 161.471L368.156 157.868L376.711 161.471L376.446 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.411 158.299H359.037V161.788H360.411V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.301 162.106L385.01 158.617L376.71 162.106L376.446 161.471L385.01 157.868L393.574 161.471L393.301 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.266 158.299H375.891V161.788H377.266V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.164 162.106L401.864 158.617L393.574 162.106L393.301 161.471L401.864 157.868L410.428 161.471L410.164 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.12 158.299H392.746V161.788H394.12V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.018 162.106L418.727 158.617L410.428 162.106L410.163 161.471L418.727 157.868L427.282 161.471L427.018 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.983 158.299H409.609V161.788H410.983V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.872 162.106L435.582 158.617L427.282 162.106L427.018 161.471L435.582 157.868L444.145 161.471L443.872 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.837 158.299H426.463V161.788H427.837V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.735 162.106L452.436 158.617L444.145 162.106L443.872 161.471L452.436 157.868L461 161.471L460.735 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.692 158.299H443.317V161.788H444.692V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.59 162.106L469.3 158.617L461 162.106L460.736 161.471L469.3 157.868L477.855 161.471L477.59 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.555 158.299H460.181V161.788H461.555V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.353 157.974L477.556 161.514L477.914 162.1L483.711 158.56L483.353 157.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.41 158.299H477.035V161.788H478.41V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.301 162.106L267.002 158.617L258.711 162.106L258.447 161.471L267.002 157.868L275.566 161.471L275.301 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.121 158.299H274.746V161.788H276.121V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.447 162.106L250.148 158.617L241.857 162.106L241.584 161.471L250.148 157.868L258.712 161.471L258.447 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.267 158.299H257.892V161.788H259.267V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.584 162.106L233.294 158.617L224.994 162.106L224.73 161.471L233.294 157.868L241.857 161.471L241.584 162.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.403 158.299H241.029V161.788H242.403V158.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.003 161.471L224.862 161.788L224.73 162.097V161.356L224.862 161.418L225.003 161.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.549 158.291H224.73V161.788H225.549V158.291Z",
    fill: "black"
  }))), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M227.204 182.705H204.587V157.771H227.204L230.684 170.238L227.204 182.705Z",
    fill: "#FFC727"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M230.684 170.238L227.204 182.705H221.433L224.913 170.238L221.433 157.771H227.204L230.684 170.238Z",
    fill: "black"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M226.506 159.137L229.458 169.727H225.881L222.929 159.137H226.506Z",
    fill: "#37474F"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M221.123 159.137L224.075 169.727H213.414V159.137H221.123Z",
    fill: "#37474F"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M225.881 170.775L222.929 181.366H226.506L229.458 170.775H225.881Z",
    fill: "#37474F"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M217.634 159.137L213.414 163.366V160.811L215.088 159.137H217.634Z",
    fill: "#151515"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M227.449 177.956L226.506 181.366H224.048L227.449 177.956Z",
    fill: "#151515"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M225.89 170.775H227.017L225.449 172.344L225.89 170.775Z",
    fill: "#151515"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M229.158 168.634L228.066 169.718H225.89L225.81 169.418L228.595 166.634L229.158 168.634Z",
    fill: "#151515"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M221.66 161.066L221.845 161.7L213.819 169.718H213.414V169.313L221.66 161.066Z",
    fill: "#151515"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M224.4 159.137L223.246 160.282L223.07 159.648L223.59 159.137H224.4Z",
    fill: "#151515"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M223.88 169.022L224.057 169.674L224.004 169.718H223.184L223.88 169.022Z",
    fill: "#151515"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M228.268 165.454L225.476 168.247L225.299 167.612L228.092 164.819L228.268 165.454Z",
    fill: "#151515"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M218.7 159.137L213.414 164.432V164.291L218.568 159.137H218.7Z",
    fill: "#151515"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M223.695 168.361L223.722 168.485L222.488 169.718H222.347L223.695 168.361Z",
    fill: "#151515"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M227.943 164.282L225.15 167.066L225.114 166.952L227.907 164.159L227.943 164.282Z",
    fill: "#151515"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M229.458 170.775L229.414 170.925L224.462 175.877L224.524 175.674L229.414 170.775H229.458Z",
    fill: "#151515"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M204.588 157.771H171.69V162.67H204.588V157.771Z",
    fill: "#FFC727"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M204.588 157.771H171.69V162.67H204.588V157.771Z",
    fill: "black"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M182.57 157.771V154.309C182.57 153.41 181.936 152.67 181.152 152.67H173.442C172.658 152.67 172.024 153.401 172.024 154.309V157.771",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M172.033 154.829H182.57",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M172.033 156.529H182.57",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M193.407 157.771V154.309C193.407 153.41 192.772 152.67 191.988 152.67H184.279C183.495 152.67 182.861 153.401 182.861 154.309V157.771",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M182.869 154.829H193.406",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M182.869 156.529H193.406",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M204.245 157.771V154.309C204.245 153.41 203.61 152.67 202.826 152.67H195.117C194.333 152.67 193.699 153.401 193.699 154.309V157.771",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M193.699 154.829H204.245",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M193.699 156.529H204.245",
    stroke: "#FFC727",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M353.546 158.07H349.696V168.264H353.546V158.07Z",
    fill: "#FFC727"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M365.52 158.07H361.669V168.264H365.52V158.07Z",
    fill: "#FFC727"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M365.52 164.282H349.696V168.264H365.52V164.282Z",
    fill: "#FFC727"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.546 158.07H349.696V168.264H353.546V158.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.52 158.07H361.669V168.264H365.52V158.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.52 164.282H349.696V168.264H365.52V164.282Z",
    fill: "black"
  }))), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M363.766 168.255H351.449V169.771H363.766V168.255Z",
    fill: "#FFC727"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M353.528 169.753V239.171",
    stroke: "#151515",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M361.643 169.753V239.171",
    stroke: "#151515",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M359.643 241.497V241.99L357.977 243.047H356.806L355.149 241.99V241.497H359.643Z",
    fill: "#FFC727"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M362.533 240.087L360.973 241.496H353.81L352.242 240.087V237.955H362.533V240.087Z",
    fill: "#FFC727"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M360.973 241.497H353.811L352.242 240.087H362.533L360.973 241.497Z",
    fill: "black"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M357.828 243.047L357.758 244.792L357.388 244.422C360.507 244.721 359.502 249.743 356.471 248.492C355.758 248.21 355.379 247.426 355.441 246.695C355.37 248.246 357.379 249.012 358.392 247.928C359.317 246.845 358.612 244.854 357.035 245.18L357.018 244.792L356.947 243.047H357.828Z",
    fill: "#FFC727"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M400.876 294.122H313.908V302.597H400.876V294.122Z",
    fill: "#FFC727"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M320.269 295.558L357.396 248.562L394.523 295.707",
    stroke: "#151515",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M400.876 294.122H313.908V302.597H400.876V294.122Z",
    fill: "#FFC727"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M400.876 294.122H313.908V302.597H400.876V294.122Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M375.81 257.311H338.991V294.13H375.81V257.311Z",
    fill: "#FFC727"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M373.969 259.144H340.824V292.289H373.969V259.144Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M344.383 259.144H343.317V292.289H344.383V259.144Z",
    fill: "#FFC727"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.392 259.144H344.049V292.289H344.392V259.144Z",
    fill: "black"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M348.903 259.144H347.837V292.289H348.903V259.144Z",
    fill: "#FFC727"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M348.904 259.144H348.56V292.289H348.904V259.144Z",
    fill: "black"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M353.414 259.144H352.348V292.289H353.414V259.144Z",
    fill: "#FFC727"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.414 259.144H353.07V292.289H353.414V259.144Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M357.925 259.144H356.859V292.289H357.925V259.144Z",
    fill: "#FFC727"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.934 259.144H357.59V292.289H357.934V259.144Z",
    fill: "black"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M362.445 259.144H361.379V292.289H362.445V259.144Z",
    fill: "#FFC727"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M362.445 259.144H362.101V292.289H362.445V259.144Z",
    fill: "black"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M366.956 259.144H365.89V292.289H366.956V259.144Z",
    fill: "#FFC727"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M366.965 259.144H366.621V292.289H366.965V259.144Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M371.467 259.144H370.401V292.289H371.467V259.144Z",
    fill: "#FFC727"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M371.476 259.144H371.132V292.289H371.476V259.144Z",
    fill: "black"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M219.697 73.5956C219.697 75.4723 218.173 76.9877 216.305 76.9877C214.437 76.9877 212.913 75.4635 212.913 73.5956C212.913 71.7278 214.437 70.2036 216.305 70.2036C218.173 70.2036 219.697 71.7278 219.697 73.5956Z",
    fill: "#151515"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M216.305 74.9524C217.054 74.9524 217.661 74.3449 217.661 73.5956C217.661 72.8462 217.054 72.2388 216.305 72.2388C215.555 72.2388 214.948 72.8462 214.948 73.5956C214.948 74.3449 215.555 74.9524 216.305 74.9524Z",
    fill: "#151515"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M173.478 161.789C173.478 163.665 171.953 165.181 170.086 165.181C168.218 165.181 166.694 163.656 166.694 161.789C166.694 159.921 168.218 158.396 170.086 158.396C171.953 158.396 173.478 159.921 173.478 161.789Z",
    fill: "#151515"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M170.085 163.145C170.834 163.145 171.442 162.538 171.442 161.788C171.442 161.039 170.834 160.432 170.085 160.432C169.336 160.432 168.728 161.039 168.728 161.788C168.728 162.538 169.336 163.145 170.085 163.145Z",
    fill: "#151515"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M431.483 143.727H427.897V148.643H431.483V143.727Z",
    fill: "#FFC727"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M432.074 148.361C432.074 149.674 431.008 150.731 429.704 150.731C428.4 150.731 427.334 149.665 427.334 148.361C427.334 147.057 428.4 145.991 429.704 145.991C431.008 145.991 432.074 147.057 432.074 148.361Z",
    fill: "#151515"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M429.695 149.304C430.216 149.304 430.638 148.882 430.638 148.361C430.638 147.841 430.216 147.418 429.695 147.418C429.175 147.418 428.753 147.841 428.753 148.361C428.753 148.882 429.175 149.304 429.695 149.304Z",
    fill: "#151515"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M171.874 275.161H168.288V280.077H171.874V275.161Z",
    fill: "#FFC727"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M172.455 279.796C172.455 281.109 171.389 282.166 170.085 282.166C168.781 282.166 167.715 281.1 167.715 279.796C167.715 278.492 168.781 277.426 170.085 277.426C171.389 277.426 172.455 278.492 172.455 279.796Z",
    fill: "#151515"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M170.085 280.738C170.606 280.738 171.028 280.316 171.028 279.796C171.028 279.275 170.606 278.853 170.085 278.853C169.564 278.853 169.142 279.275 169.142 279.796C169.142 280.316 169.564 280.738 170.085 280.738Z",
    fill: "#151515"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M172.455 383.425C172.455 384.737 171.389 385.804 170.085 385.804C168.781 385.804 167.715 384.737 167.715 383.425C167.715 382.112 168.781 381.055 170.085 381.055C171.389 381.055 172.455 382.121 172.455 383.425Z",
    fill: "#151515"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M170.085 384.367C170.606 384.367 171.028 383.945 171.028 383.425C171.028 382.904 170.606 382.482 170.085 382.482C169.565 382.482 169.143 382.904 169.143 383.425C169.143 383.945 169.565 384.367 170.085 384.367Z",
    fill: "#151515"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M215.785 428.49H216.816C219.001 428.49 220.772 430.261 220.772 432.446V437.433H211.829V432.446C211.829 430.261 213.6 428.49 215.785 428.49Z",
    fill: "#FFC727"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M216.305 433.591C216.927 433.591 217.432 433.087 217.432 432.464C217.432 431.841 216.927 431.336 216.305 431.336C215.682 431.336 215.177 431.841 215.177 432.464C215.177 433.087 215.682 433.591 216.305 433.591Z",
    fill: "#00A48C"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 413.663H153.601V417.469H181.997V413.663Z",
    fill: "#00A48C"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 417.469H186.57V413.663H181.997V417.469Z",
    fill: "#37474F"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 409.856H153.601V413.663H181.997V409.856Z",
    fill: "#00A48C"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 413.663H186.57V409.856H181.997V413.663Z",
    fill: "#37474F"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M153.601 413.663C164.588 413.53 175.574 413.522 186.561 413.663C175.574 413.803 164.588 413.795 153.601 413.663Z",
    fill: "#00A48C"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 406.05H153.601V409.856H181.997V406.05Z",
    fill: "#00A48C"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 409.865H186.57V406.059H181.997V409.865Z",
    fill: "#37474F"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M153.601 409.856C164.588 409.724 175.574 409.715 186.561 409.856C175.574 409.997 164.588 409.989 153.601 409.856Z",
    fill: "#00A48C"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 402.253H153.601V406.06H181.997V402.253Z",
    fill: "#00A48C"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 406.05H186.57V402.244H181.997V406.05Z",
    fill: "#37474F"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M153.601 406.05C164.588 405.918 175.574 405.909 186.561 406.05C175.574 406.191 164.588 406.182 153.601 406.05Z",
    fill: "#00A48C"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 398.447H153.601V402.253H181.997V398.447Z",
    fill: "#00A48C"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 402.253H186.57V398.447H181.997V402.253Z",
    fill: "#37474F"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M153.601 402.253C164.588 402.121 175.574 402.112 186.561 402.253C175.574 402.394 164.588 402.385 153.601 402.253Z",
    fill: "#00A48C"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 394.641H153.601V398.447H181.997V394.641Z",
    fill: "#00A48C"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M181.997 398.447H186.57V394.641H181.997V398.447Z",
    fill: "#37474F"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M153.601 398.447C164.588 398.315 175.574 398.306 186.561 398.447C175.574 398.588 164.588 398.579 153.601 398.447Z",
    fill: "#00A48C"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M170.711 385.759H169.468V394.64H170.711V385.759Z",
    fill: "#FFC727"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M296.843 453.195H351.186C351.186 453.195 326.648 425.627 296.843 453.195Z",
    fill: "#FFC727"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M296.843 453.195H351.186C351.186 453.195 326.648 425.627 296.843 453.195Z",
    fill: "black"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M329.149 449.257C329.149 448.957 328.903 448.71 328.603 448.71C328.304 448.71 328.057 448.957 328.057 449.257C328.057 449.556 328.304 449.803 328.603 449.803C328.903 449.803 329.149 449.556 329.149 449.257Z",
    fill: "black"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M317.062 444.851C317.062 444.552 316.815 444.305 316.516 444.305C316.216 444.305 315.969 444.552 315.969 444.851C315.969 445.151 316.216 445.398 316.516 445.398C316.815 445.398 317.062 445.151 317.062 444.851Z",
    fill: "black"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M318.736 448.323C318.736 448.023 318.489 447.776 318.19 447.776C317.89 447.776 317.644 448.023 317.644 448.323C317.644 448.622 317.89 448.869 318.19 448.869C318.489 448.869 318.736 448.622 318.736 448.323Z",
    fill: "black"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M307.08 447.953C307.381 447.953 307.626 447.708 307.626 447.407C307.626 447.105 307.381 446.86 307.08 446.86C306.778 446.86 306.533 447.105 306.533 447.407C306.533 447.708 306.778 447.953 307.08 447.953Z",
    fill: "black"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M339.511 451.433C339.511 451.133 339.265 450.887 338.965 450.887C338.666 450.887 338.419 451.133 338.419 451.433C338.419 451.733 338.666 451.979 338.965 451.979C339.265 451.979 339.511 451.733 339.511 451.433Z",
    fill: "black"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M319.282 451.979C319.282 451.68 319.036 451.433 318.736 451.433C318.437 451.433 318.19 451.68 318.19 451.979C318.19 452.279 318.437 452.526 318.736 452.526C319.036 452.526 319.282 452.279 319.282 451.979Z",
    fill: "black"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M331.978 450.675C331.978 450.455 331.802 450.288 331.59 450.288C331.379 450.288 331.203 450.464 331.203 450.675C331.203 450.887 331.379 451.063 331.59 451.063C331.802 451.063 331.978 450.887 331.978 450.675Z",
    fill: "black"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M321.318 447.01C321.318 446.79 321.141 446.623 320.93 446.623C320.719 446.623 320.542 446.799 320.542 447.01C320.542 447.222 320.719 447.398 320.93 447.398C321.141 447.398 321.318 447.222 321.318 447.01Z",
    fill: "black"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M334.762 445.997C334.762 445.776 334.586 445.609 334.375 445.609C334.163 445.609 333.987 445.785 333.987 445.997C333.987 446.208 334.163 446.384 334.375 446.384C334.586 446.384 334.762 446.208 334.762 445.997Z",
    fill: "black"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M344.859 449.803C344.859 449.583 344.683 449.416 344.471 449.416C344.26 449.416 344.084 449.592 344.084 449.803C344.084 450.015 344.26 450.191 344.471 450.191C344.683 450.191 344.859 450.015 344.859 449.803Z",
    fill: "black"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M282.516 453.195H320.049C320.049 453.195 303.097 434.156 282.516 453.195Z",
    fill: "#FFC727"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M282.516 453.195H320.049C320.049 453.195 303.097 434.156 282.516 453.195Z",
    fill: "black"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M304.11 449.918C304.11 450.217 304.357 450.464 304.656 450.464C304.956 450.464 305.203 450.217 305.203 449.918C305.203 449.618 304.956 449.372 304.656 449.372C304.357 449.372 304.11 449.618 304.11 449.918Z",
    fill: "black"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M314.524 450.852C314.524 451.151 314.771 451.398 315.071 451.398C315.37 451.398 315.617 451.151 315.617 450.852C315.617 450.552 315.37 450.306 315.071 450.306C314.771 450.306 314.524 450.552 314.524 450.852Z",
    fill: "black"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M293.749 447.742C293.749 448.041 293.996 448.288 294.295 448.288C294.595 448.288 294.842 448.041 294.842 447.742C294.842 447.442 294.595 447.195 294.295 447.195C293.996 447.195 293.749 447.442 293.749 447.742Z",
    fill: "black"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M301.282 448.491C301.282 448.711 301.458 448.878 301.67 448.878C301.881 448.878 302.057 448.702 302.057 448.491C302.057 448.279 301.881 448.103 301.67 448.103C301.458 448.103 301.282 448.279 301.282 448.491Z",
    fill: "black"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M312.339 452.552C312.554 452.552 312.727 452.379 312.727 452.165C312.727 451.95 312.554 451.777 312.339 451.777C312.125 451.777 311.952 451.95 311.952 452.165C311.952 452.379 312.125 452.552 312.339 452.552Z",
    fill: "black"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.771 450.852C290.771 451.072 290.948 451.239 291.159 451.239C291.37 451.239 291.547 451.063 291.547 450.852C291.547 450.64 291.37 450.464 291.159 450.464C290.948 450.464 290.771 450.64 290.771 450.852Z",
    fill: "black"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M425.95 453.195H463.483C463.483 453.195 446.532 434.156 425.95 453.195Z",
    fill: "#FFC727"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M425.95 453.195H463.483C463.483 453.195 446.532 434.156 425.95 453.195Z",
    fill: "black"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M447.545 449.918C447.545 450.217 447.792 450.464 448.091 450.464C448.391 450.464 448.637 450.217 448.637 449.918C448.637 449.618 448.391 449.372 448.091 449.372C447.792 449.372 447.545 449.618 447.545 449.918Z",
    fill: "black"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M457.959 450.852C457.959 451.151 458.206 451.398 458.505 451.398C458.805 451.398 459.052 451.151 459.052 450.852C459.052 450.552 458.805 450.306 458.505 450.306C458.206 450.306 457.959 450.552 457.959 450.852Z",
    fill: "black"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M437.184 447.742C437.184 448.041 437.431 448.288 437.73 448.288C438.03 448.288 438.276 448.041 438.276 447.742C438.276 447.442 438.03 447.195 437.73 447.195C437.431 447.195 437.184 447.442 437.184 447.742Z",
    fill: "black"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M445.114 448.878C445.328 448.878 445.502 448.705 445.502 448.491C445.502 448.277 445.328 448.103 445.114 448.103C444.9 448.103 444.726 448.277 444.726 448.491C444.726 448.705 444.9 448.878 445.114 448.878Z",
    fill: "black"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M455.774 452.552C455.988 452.552 456.162 452.379 456.162 452.165C456.162 451.95 455.988 451.777 455.774 451.777C455.56 451.777 455.387 451.95 455.387 452.165C455.387 452.379 455.56 452.552 455.774 452.552Z",
    fill: "black"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M434.206 450.852C434.206 451.072 434.382 451.239 434.594 451.239C434.805 451.239 434.982 451.063 434.982 450.852C434.982 450.64 434.805 450.464 434.594 450.464C434.382 450.464 434.206 450.64 434.206 450.852Z",
    fill: "black"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M452.205 453.195H478.813C478.813 453.195 466.796 439.698 452.205 453.195Z",
    fill: "#FFC727"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M452.205 453.195H478.813C478.813 453.195 466.796 439.698 452.205 453.195Z",
    fill: "black"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M468.029 451.266C468.029 451.116 467.906 451.001 467.765 451.001C467.624 451.001 467.5 451.125 467.5 451.266C467.5 451.407 467.624 451.53 467.765 451.53C467.906 451.53 468.029 451.407 468.029 451.266Z",
    fill: "black"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M462.108 449.107C462.108 448.957 461.985 448.843 461.844 448.843C461.703 448.843 461.58 448.966 461.58 449.107C461.58 449.248 461.703 449.371 461.844 449.371C461.985 449.371 462.108 449.248 462.108 449.107Z",
    fill: "black"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M462.928 450.807C462.928 450.657 462.804 450.543 462.663 450.543C462.522 450.543 462.399 450.666 462.399 450.807C462.399 450.948 462.522 451.072 462.663 451.072C462.804 451.072 462.928 450.948 462.928 450.807Z",
    fill: "black"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M457.219 450.622C457.365 450.622 457.483 450.504 457.483 450.358C457.483 450.212 457.365 450.094 457.219 450.094C457.073 450.094 456.954 450.212 456.954 450.358C456.954 450.504 457.073 450.622 457.219 450.622Z",
    fill: "black"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M473.104 452.332C473.104 452.182 472.981 452.067 472.84 452.067C472.699 452.067 472.576 452.191 472.576 452.332C472.576 452.473 472.699 452.596 472.84 452.596C472.981 452.596 473.104 452.473 473.104 452.332Z",
    fill: "black"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M463.201 452.596C463.201 452.446 463.078 452.332 462.937 452.332C462.796 452.332 462.673 452.455 462.673 452.596C462.673 452.737 462.796 452.86 462.937 452.86C463.078 452.86 463.201 452.737 463.201 452.596Z",
    fill: "black"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M469.413 451.962C469.413 451.856 469.324 451.768 469.219 451.768C469.113 451.768 469.025 451.856 469.025 451.962C469.025 452.068 469.113 452.156 469.219 452.156C469.324 452.156 469.413 452.068 469.413 451.962Z",
    fill: "black"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M464.197 450.173C464.197 450.068 464.109 449.979 464.003 449.979C463.897 449.979 463.809 450.068 463.809 450.173C463.809 450.279 463.897 450.367 464.003 450.367C464.109 450.367 464.197 450.279 464.197 450.173Z",
    fill: "black"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M470.778 449.671C470.778 449.565 470.69 449.477 470.584 449.477C470.478 449.477 470.39 449.565 470.39 449.671C470.39 449.777 470.478 449.865 470.584 449.865C470.69 449.865 470.778 449.777 470.778 449.671Z",
    fill: "black"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M475.721 451.539C475.721 451.433 475.633 451.345 475.527 451.345C475.421 451.345 475.333 451.433 475.333 451.539C475.333 451.645 475.421 451.733 475.527 451.733C475.633 451.733 475.721 451.645 475.721 451.539Z",
    fill: "black"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M261.918 439.354L261.759 440.517L261.583 441.776L259.971 453.195H257.337L258.949 441.776L259.125 440.517L259.284 439.354H261.918Z",
    fill: "#FFC727"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.539 439.354C261.398 440.508 261.248 441.662 261.098 442.825L260.631 446.287L260.147 449.75L259.891 451.477L259.627 453.204L259.838 451.468L260.059 449.732L260.526 446.27L261.01 442.807C261.178 441.653 261.345 440.499 261.521 439.354H261.539Z",
    fill: "black"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.76 440.517L261.583 441.776H258.949L259.125 440.517H261.76Z",
    fill: "black"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M274.922 439.354L275.089 440.517L275.265 441.776L276.878 453.195H279.512L277.9 441.776L277.724 440.517L277.556 439.354H274.922Z",
    fill: "#FFC727"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M275.319 439.354C275.46 440.508 275.609 441.662 275.759 442.825L276.226 446.287L276.711 449.75L276.966 451.477L277.23 453.204L277.019 451.468L276.799 449.732L276.332 446.27L275.847 442.807C275.68 441.653 275.512 440.499 275.336 439.354H275.319Z",
    fill: "black"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M275.09 440.517H277.724L277.9 441.776H275.266L275.09 440.517Z",
    fill: "black"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M261.829 436.957H259.732L259.997 435.01H261.565L261.829 436.957Z",
    fill: "#FFC727"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.829 436.957H259.732L259.997 435.01H261.565L261.829 436.957Z",
    fill: "black"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M260.781 435.565C261.856 435.565 262.728 434.693 262.728 433.618C262.728 432.543 261.856 431.671 260.781 431.671C259.706 431.671 258.834 432.543 258.834 433.618C258.834 434.693 259.706 435.565 260.781 435.565Z",
    fill: "#FFC727"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M260.781 435.098C261.599 435.098 262.262 434.435 262.262 433.618C262.262 432.8 261.599 432.138 260.781 432.138C259.964 432.138 259.301 432.8 259.301 433.618C259.301 434.435 259.964 435.098 260.781 435.098Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M262.015 433.53C261.989 433.169 261.804 432.834 261.53 432.623C261.257 432.411 260.896 432.305 260.535 432.358C260.191 432.411 259.874 432.614 259.68 432.913C259.486 433.213 259.416 433.6 259.522 433.979C259.61 434.288 259.821 434.552 260.103 434.711C260.376 434.869 260.711 434.913 261.011 434.852C261.31 434.79 261.583 434.623 261.768 434.385C261.953 434.156 262.068 433.865 262.077 433.556C262.077 433.539 262.077 433.53 262.068 433.53C262.068 433.53 262.05 433.539 262.05 433.556C262.05 433.68 262.015 433.794 261.98 433.909C261.936 434.023 261.883 434.129 261.812 434.226C261.742 434.323 261.663 434.411 261.566 434.49C261.469 434.57 261.372 434.631 261.257 434.693C260.94 434.843 260.57 434.852 260.244 434.719C259.918 434.587 259.663 434.305 259.557 433.971C259.442 433.609 259.504 433.23 259.689 432.931C259.874 432.64 260.182 432.429 260.526 432.385C260.993 432.314 261.469 432.49 261.751 432.869C261.821 432.966 261.874 433.072 261.918 433.178C261.962 433.283 261.98 433.407 261.997 433.521C261.997 433.521 261.997 433.521 261.997 433.512L262.015 433.53Z",
    fill: "#FFC727"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M261.847 433.539C261.821 433.231 261.662 432.949 261.424 432.764C261.187 432.579 260.887 432.499 260.579 432.535C260.279 432.579 260.006 432.746 259.839 433.01C259.662 433.266 259.61 433.609 259.698 433.935C259.768 434.209 259.953 434.438 260.2 434.579C260.438 434.72 260.728 434.755 260.993 434.693C261.257 434.64 261.486 434.49 261.654 434.288C261.812 434.085 261.909 433.838 261.927 433.574C261.927 433.565 261.927 433.548 261.918 433.548C261.918 433.548 261.9 433.557 261.9 433.574C261.883 433.997 261.609 434.376 261.222 434.561C260.949 434.693 260.632 434.702 260.35 434.587C260.068 434.473 259.847 434.226 259.759 433.935C259.662 433.627 259.715 433.292 259.874 433.046C260.032 432.79 260.306 432.623 260.587 432.587C260.984 432.535 261.38 432.675 261.636 433.001C261.698 433.081 261.742 433.169 261.777 433.266C261.812 433.363 261.83 433.46 261.847 433.557V433.539Z",
    fill: "#FFC727"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M261.671 433.539C261.645 433.274 261.513 433.045 261.319 432.896C261.125 432.746 260.869 432.675 260.614 432.702C260.367 432.728 260.138 432.878 259.988 433.089C259.839 433.301 259.786 433.592 259.856 433.874C259.918 434.103 260.076 434.305 260.279 434.42C260.482 434.534 260.728 434.57 260.957 434.517C261.178 434.464 261.38 434.34 261.513 434.164C261.645 433.988 261.733 433.777 261.742 433.556C261.742 433.548 261.742 433.539 261.733 433.539C261.733 433.539 261.715 433.539 261.715 433.556C261.698 433.918 261.468 434.226 261.142 434.385C260.913 434.499 260.64 434.508 260.402 434.411C260.165 434.314 259.971 434.103 259.9 433.856C259.821 433.592 259.865 433.318 260.006 433.107C260.147 432.896 260.367 432.755 260.605 432.728C260.772 432.711 260.931 432.728 261.081 432.781C261.231 432.834 261.363 432.931 261.468 433.063C261.521 433.133 261.557 433.204 261.592 433.274C261.618 433.354 261.645 433.433 261.654 433.521L261.671 433.539Z",
    fill: "#FFC727"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M261.495 433.539C261.468 433.327 261.363 433.151 261.204 433.028C261.045 432.913 260.852 432.852 260.64 432.869C260.446 432.887 260.252 433.001 260.129 433.169C260.006 433.336 259.953 433.574 260.015 433.812C260.059 434.006 260.191 434.173 260.367 434.27C260.534 434.367 260.746 434.393 260.922 434.349C261.107 434.305 261.266 434.2 261.371 434.059C261.477 433.918 261.548 433.741 261.556 433.565C261.556 433.565 261.556 433.548 261.548 433.548C261.548 433.548 261.53 433.548 261.53 433.565C261.512 433.856 261.327 434.103 261.063 434.235C260.887 434.332 260.658 434.341 260.464 434.261C260.27 434.182 260.112 434.015 260.059 433.812C259.997 433.6 260.041 433.371 260.156 433.204C260.27 433.037 260.455 432.931 260.64 432.913C260.772 432.904 260.896 432.913 261.019 432.957C261.134 433.001 261.248 433.072 261.327 433.178C261.371 433.23 261.398 433.283 261.424 433.345C261.451 433.407 261.468 433.468 261.477 433.539H261.495Z",
    fill: "#FFC727"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M277.062 436.957H274.974L275.238 435.01H276.807L277.062 436.957Z",
    fill: "#FFC727"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M277.062 436.957H274.974L275.238 435.01H276.807L277.062 436.957Z",
    fill: "black"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M277.97 433.618C277.97 434.693 277.098 435.565 276.023 435.565C274.948 435.565 274.076 434.693 274.076 433.618C274.076 432.543 274.948 431.671 276.023 431.671C277.098 431.671 277.97 432.543 277.97 433.618Z",
    fill: "#FFC727"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M277.503 433.618C277.503 434.437 276.842 435.098 276.023 435.098C275.204 435.098 274.543 434.437 274.543 433.618C274.543 432.799 275.204 432.138 276.023 432.138C276.842 432.138 277.503 432.799 277.503 433.618Z",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M277.256 433.53C277.23 433.169 277.045 432.834 276.772 432.623C276.499 432.411 276.137 432.305 275.776 432.358C275.433 432.411 275.115 432.614 274.922 432.913C274.728 433.213 274.657 433.6 274.763 433.979C274.851 434.288 275.063 434.552 275.344 434.711C275.618 434.869 275.952 434.913 276.252 434.852C276.552 434.79 276.825 434.623 277.01 434.385C277.195 434.156 277.309 433.865 277.318 433.556C277.318 433.539 277.318 433.53 277.309 433.53C277.309 433.53 277.292 433.539 277.292 433.556C277.292 433.68 277.256 433.794 277.221 433.909C277.177 434.023 277.124 434.129 277.054 434.226C276.983 434.323 276.904 434.411 276.807 434.49C276.71 434.57 276.613 434.631 276.499 434.693C276.181 434.843 275.811 434.852 275.485 434.719C275.159 434.587 274.904 434.305 274.798 433.971C274.684 433.609 274.745 433.23 274.93 432.931C275.115 432.64 275.424 432.429 275.767 432.385C276.234 432.314 276.71 432.49 276.992 432.869C277.063 432.966 277.115 433.072 277.159 433.178C277.203 433.283 277.221 433.407 277.239 433.521C277.239 433.521 277.239 433.521 277.239 433.512L277.256 433.53Z",
    fill: "#FFC727"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M277.08 433.539C277.054 433.231 276.895 432.949 276.657 432.764C276.419 432.579 276.12 432.499 275.811 432.535C275.512 432.579 275.239 432.746 275.071 433.01C274.895 433.266 274.842 433.609 274.93 433.935C275.001 434.209 275.186 434.438 275.433 434.579C275.67 434.72 275.961 434.755 276.226 434.693C276.49 434.64 276.719 434.49 276.886 434.288C277.045 434.085 277.142 433.838 277.159 433.574C277.159 433.565 277.159 433.548 277.151 433.548C277.151 433.548 277.133 433.557 277.133 433.574C277.115 433.997 276.842 434.376 276.455 434.561C276.181 434.693 275.855 434.702 275.582 434.587C275.3 434.473 275.08 434.226 274.992 433.935C274.895 433.627 274.948 433.292 275.107 433.046C275.265 432.79 275.538 432.623 275.82 432.587C276.217 432.535 276.613 432.675 276.869 433.001C276.93 433.081 276.974 433.169 277.01 433.266C277.045 433.363 277.063 433.46 277.08 433.557V433.539Z",
    fill: "#FFC727"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M276.912 433.539C276.886 433.274 276.754 433.045 276.56 432.896C276.366 432.746 276.111 432.675 275.855 432.702C275.609 432.728 275.379 432.878 275.23 433.089C275.08 433.301 275.027 433.592 275.098 433.874C275.159 434.103 275.318 434.305 275.52 434.42C275.723 434.534 275.97 434.57 276.199 434.517C276.419 434.464 276.622 434.34 276.754 434.164C276.886 433.988 276.974 433.777 276.983 433.556C276.983 433.548 276.983 433.539 276.974 433.539C276.974 433.539 276.957 433.539 276.957 433.556C276.939 433.918 276.71 434.226 276.384 434.385C276.155 434.499 275.882 434.508 275.644 434.411C275.406 434.314 275.212 434.103 275.142 433.856C275.062 433.592 275.106 433.318 275.247 433.107C275.388 432.896 275.609 432.755 275.846 432.728C276.014 432.711 276.172 432.728 276.322 432.781C276.472 432.834 276.604 432.931 276.71 433.063C276.763 433.133 276.798 433.204 276.833 433.274C276.86 433.354 276.886 433.433 276.895 433.521L276.912 433.539Z",
    fill: "#FFC727"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M276.736 433.539C276.71 433.327 276.604 433.151 276.445 433.028C276.287 432.913 276.093 432.852 275.881 432.869C275.688 432.887 275.494 433.001 275.37 433.169C275.247 433.336 275.194 433.574 275.256 433.812C275.3 434.006 275.432 434.173 275.608 434.27C275.776 434.367 275.987 434.393 276.163 434.349C276.348 434.305 276.507 434.2 276.613 434.059C276.718 433.918 276.789 433.741 276.798 433.565C276.798 433.565 276.798 433.548 276.789 433.548C276.789 433.548 276.771 433.548 276.771 433.565C276.754 433.856 276.569 434.103 276.304 434.235C276.128 434.332 275.899 434.341 275.705 434.261C275.511 434.182 275.353 434.015 275.3 433.812C275.238 433.6 275.282 433.371 275.397 433.204C275.511 433.037 275.696 432.931 275.881 432.913C276.014 432.904 276.137 432.913 276.26 432.957C276.375 433.001 276.489 433.072 276.569 433.178C276.613 433.23 276.639 433.283 276.666 433.345C276.692 433.407 276.71 433.468 276.718 433.539H276.736Z",
    fill: "#FFC727"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M281.548 435.961H255.301V440.983H281.548V435.961Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M281.609 441.045H255.239V435.9H281.609V441.045ZM255.362 440.922H281.486V436.023H255.362V440.922Z",
    fill: "#00A48C"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M260.693 435.961L258.79 440.983H255.398L257.301 435.961H260.693Z",
    fill: "#FFC727"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M267.644 435.961L265.741 440.983H262.349L264.252 435.961H267.644Z",
    fill: "#FFC727"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M274.587 435.961L272.684 440.983H269.292L271.203 435.961H274.587Z",
    fill: "#FFC727"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M281.539 435.961L279.636 440.983H276.244L278.147 435.961H281.539Z",
    fill: "#FFC727"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M281.01 447.124H255.829V450.305H281.01V447.124Z",
    fill: "white"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M281.08 450.358H255.767V447.054H281.08V450.358ZM255.891 450.234H280.948V447.186H255.891V450.234Z",
    fill: "#00A48C"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M261.01 447.124L259.177 450.296H255.926L257.759 447.124H261.01Z",
    fill: "#FFC727"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M267.671 447.124L265.847 450.296H262.596L264.42 447.124H267.671Z",
    fill: "#FFC727"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 447.124L272.516 450.296H269.256L271.089 447.124H274.34Z",
    fill: "#FFC727"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M281.01 447.124L279.177 450.296H275.926L277.75 447.124H281.01Z",
    fill: "#FFC727"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M272.507 438.472C272.507 440.728 270.675 442.56 268.419 442.56C266.164 442.56 264.331 440.728 264.331 438.472C264.331 436.217 266.164 434.384 268.419 434.384C270.675 434.384 272.507 436.217 272.507 438.472Z",
    fill: "white"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M268.419 442.622C266.128 442.622 264.269 440.763 264.269 438.472C264.269 436.182 266.128 434.323 268.419 434.323C270.71 434.323 272.569 436.182 272.569 438.472C272.569 440.763 270.71 442.622 268.419 442.622ZM268.419 434.455C266.199 434.455 264.401 436.261 264.401 438.481C264.401 440.702 266.207 442.499 268.419 442.499C270.63 442.499 272.436 440.693 272.436 438.481C272.436 436.27 270.63 434.455 268.419 434.455Z",
    fill: "#00A48C"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M271.882 438.472C271.882 440.384 270.331 441.935 268.419 441.935C266.508 441.935 264.957 440.384 264.957 438.472C264.957 436.56 266.508 435.01 268.419 435.01C270.331 435.01 271.882 436.56 271.882 438.472Z",
    fill: "#FFC727"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M270.595 438.076H266.252V438.878H270.595V438.076Z",
    fill: "white"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M416.647 439.354L416.479 440.517L416.303 441.776L414.691 453.195H412.057L413.669 441.776L413.845 440.517L414.013 439.354H416.647Z",
    fill: "#FFC727"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M416.259 439.354C416.118 440.508 415.968 441.662 415.818 442.825L415.351 446.287L414.867 449.75L414.611 451.477L414.347 453.204L414.558 451.468L414.779 449.732L415.246 446.27L415.73 442.807C415.898 441.653 416.065 440.499 416.241 439.354H416.259Z",
    fill: "black"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M416.48 440.517L416.303 441.776H413.669L413.845 440.517H416.48Z",
    fill: "black"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M429.651 439.354L429.81 440.517L429.986 441.776L431.598 453.195H434.233L432.62 441.776L432.444 440.517L432.286 439.354H429.651Z",
    fill: "#FFC727"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M430.039 439.354C430.18 440.508 430.33 441.662 430.48 442.825L430.947 446.287L431.431 449.75L431.687 451.477L431.951 453.204L431.74 451.468L431.52 449.732L431.053 446.27L430.568 442.807C430.401 441.653 430.233 440.499 430.057 439.354H430.039Z",
    fill: "black"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M429.81 440.517H432.444L432.62 441.776H429.986L429.81 440.517Z",
    fill: "black"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M416.551 436.957H414.463L414.718 435.01H416.286L416.551 436.957Z",
    fill: "#FFC727"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M416.551 436.957H414.463L414.718 435.01H416.286L416.551 436.957Z",
    fill: "black"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M417.449 433.618C417.449 434.692 416.576 435.565 415.501 435.565C414.427 435.565 413.554 434.692 413.554 433.618C413.554 432.543 414.427 431.67 415.501 431.67C416.576 431.67 417.449 432.543 417.449 433.618Z",
    fill: "#FFC727"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M416.982 433.617C416.982 434.437 416.321 435.098 415.502 435.098C414.682 435.098 414.021 434.437 414.021 433.617C414.021 432.798 414.682 432.137 415.502 432.137C416.321 432.137 416.982 432.798 416.982 433.617Z",
    fill: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M416.744 433.53C416.717 433.168 416.532 432.833 416.259 432.622C415.986 432.411 415.625 432.305 415.264 432.358C414.92 432.411 414.603 432.613 414.409 432.913C414.215 433.212 414.145 433.6 414.25 433.979C414.339 434.287 414.55 434.552 414.832 434.71C415.105 434.869 415.44 434.913 415.739 434.851C416.039 434.789 416.312 434.622 416.497 434.384C416.682 434.155 416.797 433.864 416.805 433.556C416.805 433.538 416.805 433.53 416.797 433.53C416.797 433.53 416.779 433.538 416.779 433.556C416.779 433.679 416.744 433.794 416.709 433.908C416.664 434.023 416.612 434.129 416.541 434.226C416.471 434.322 416.391 434.411 416.294 434.49C416.198 434.569 416.101 434.631 415.986 434.693C415.669 434.842 415.299 434.851 414.973 434.719C414.647 434.587 414.391 434.305 414.286 433.97C414.171 433.609 414.233 433.23 414.418 432.93C414.603 432.64 414.911 432.428 415.255 432.384C415.722 432.314 416.198 432.49 416.479 432.869C416.55 432.966 416.603 433.071 416.647 433.177C416.691 433.283 416.709 433.406 416.726 433.521C416.726 433.521 416.726 433.521 416.726 433.512L416.744 433.53Z",
    fill: "#FFC727"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M416.568 433.538C416.541 433.23 416.383 432.948 416.145 432.763C415.907 432.578 415.607 432.499 415.299 432.534C414.999 432.578 414.726 432.746 414.559 433.01C414.383 433.265 414.33 433.609 414.418 433.935C414.488 434.208 414.673 434.437 414.92 434.578C415.158 434.719 415.449 434.754 415.713 434.693C415.977 434.64 416.206 434.49 416.374 434.287C416.532 434.085 416.629 433.838 416.647 433.574C416.647 433.565 416.647 433.547 416.638 433.547C416.638 433.547 416.62 433.556 416.62 433.574C416.603 433.997 416.33 434.375 415.942 434.56C415.669 434.693 415.352 434.701 415.07 434.587C414.788 434.472 414.568 434.226 414.48 433.935C414.383 433.627 414.435 433.292 414.594 433.045C414.753 432.79 415.026 432.622 415.308 432.587C415.704 432.534 416.101 432.675 416.356 433.001C416.418 433.08 416.462 433.168 416.497 433.265C416.532 433.362 416.55 433.459 416.568 433.556V433.538Z",
    fill: "#FFC727"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M416.391 433.538C416.365 433.274 416.233 433.045 416.039 432.895C415.845 432.745 415.59 432.675 415.334 432.701C415.087 432.728 414.858 432.877 414.709 433.089C414.559 433.3 414.506 433.591 414.576 433.873C414.638 434.102 414.797 434.305 414.999 434.419C415.202 434.534 415.449 434.569 415.678 434.516C415.898 434.463 416.101 434.34 416.233 434.164C416.365 433.988 416.453 433.776 416.462 433.556C416.462 433.547 416.462 433.538 416.453 433.538C416.453 433.538 416.435 433.538 416.435 433.556C416.418 433.917 416.189 434.225 415.863 434.384C415.634 434.499 415.361 434.507 415.123 434.41C414.885 434.314 414.691 434.102 414.62 433.855C414.541 433.591 414.585 433.318 414.726 433.107C414.867 432.895 415.087 432.754 415.325 432.728C415.493 432.71 415.651 432.728 415.801 432.781C415.951 432.833 416.083 432.93 416.189 433.062C416.242 433.133 416.277 433.203 416.312 433.274C416.338 433.353 416.365 433.433 416.374 433.521L416.391 433.538Z",
    fill: "#FFC727"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M416.225 433.538C416.198 433.327 416.092 433.151 415.934 433.027C415.775 432.913 415.581 432.851 415.37 432.869C415.176 432.886 414.982 433.001 414.859 433.168C414.736 433.336 414.683 433.574 414.744 433.811C414.788 434.005 414.921 434.173 415.097 434.27C415.264 434.366 415.476 434.393 415.652 434.349C415.837 434.305 415.995 434.199 416.101 434.058C416.207 433.917 416.277 433.741 416.286 433.565C416.286 433.565 416.286 433.547 416.277 433.547C416.277 433.547 416.26 433.547 416.26 433.565C416.242 433.855 416.057 434.102 415.793 434.234C415.617 434.331 415.388 434.34 415.194 434.261C415 434.181 414.841 434.014 414.788 433.811C414.727 433.6 414.771 433.371 414.885 433.203C415 433.036 415.185 432.93 415.37 432.913C415.502 432.904 415.625 432.913 415.749 432.957C415.863 433.001 415.978 433.071 416.057 433.177C416.101 433.23 416.128 433.283 416.154 433.344C416.18 433.406 416.198 433.468 416.207 433.538H416.225Z",
    fill: "#FFC727"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M431.784 436.957H429.696L429.96 435.01H431.528L431.784 436.957Z",
    fill: "#FFC727"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M431.784 436.957H429.696L429.96 435.01H431.528L431.784 436.957Z",
    fill: "black"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M432.692 433.618C432.692 434.692 431.82 435.565 430.745 435.565C429.67 435.565 428.798 434.692 428.798 433.618C428.798 432.543 429.67 431.67 430.745 431.67C431.82 431.67 432.692 432.543 432.692 433.618Z",
    fill: "#FFC727"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M432.225 433.617C432.225 434.437 431.564 435.098 430.745 435.098C429.926 435.098 429.265 434.437 429.265 433.617C429.265 432.798 429.926 432.137 430.745 432.137C431.564 432.137 432.225 432.798 432.225 433.617Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M431.979 433.53C431.952 433.168 431.767 432.833 431.494 432.622C431.221 432.411 430.86 432.305 430.498 432.358C430.155 432.411 429.838 432.613 429.644 432.913C429.45 433.212 429.38 433.6 429.485 433.979C429.573 434.287 429.785 434.552 430.067 434.71C430.34 434.869 430.675 434.913 430.974 434.851C431.274 434.789 431.547 434.622 431.732 434.384C431.917 434.155 432.031 433.864 432.04 433.556C432.04 433.538 432.04 433.53 432.031 433.53C432.031 433.53 432.014 433.538 432.014 433.556C432.014 433.679 431.979 433.794 431.943 433.908C431.899 434.023 431.846 434.129 431.776 434.226C431.706 434.322 431.626 434.411 431.529 434.49C431.432 434.569 431.335 434.631 431.221 434.693C430.904 434.842 430.534 434.851 430.208 434.719C429.882 434.587 429.626 434.305 429.521 433.97C429.406 433.609 429.468 433.23 429.653 432.93C429.838 432.64 430.146 432.428 430.49 432.384C430.957 432.314 431.432 432.49 431.714 432.869C431.785 432.966 431.838 433.071 431.882 433.177C431.926 433.283 431.943 433.406 431.961 433.521C431.961 433.521 431.961 433.521 431.961 433.512L431.979 433.53Z",
    fill: "#FFC727"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M431.811 433.538C431.785 433.23 431.626 432.948 431.388 432.763C431.15 432.578 430.851 432.499 430.542 432.534C430.243 432.578 429.97 432.746 429.802 433.01C429.626 433.265 429.573 433.609 429.661 433.935C429.732 434.208 429.917 434.437 430.163 434.578C430.401 434.719 430.692 434.754 430.956 434.693C431.221 434.64 431.45 434.49 431.617 434.287C431.776 434.085 431.873 433.838 431.89 433.574C431.89 433.565 431.89 433.547 431.881 433.547C431.881 433.547 431.864 433.556 431.864 433.574C431.846 433.997 431.573 434.375 431.185 434.56C430.912 434.693 430.586 434.701 430.313 434.587C430.031 434.472 429.811 434.226 429.723 433.935C429.626 433.627 429.679 433.292 429.837 433.045C429.996 432.79 430.269 432.622 430.551 432.587C430.948 432.534 431.344 432.675 431.6 433.001C431.661 433.08 431.705 433.168 431.741 433.265C431.776 433.362 431.793 433.459 431.811 433.556V433.538Z",
    fill: "#FFC727"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M431.635 433.538C431.608 433.274 431.476 433.045 431.282 432.895C431.089 432.745 430.833 432.675 430.577 432.701C430.331 432.728 430.102 432.877 429.952 433.089C429.802 433.3 429.749 433.591 429.82 433.873C429.881 434.102 430.04 434.305 430.243 434.419C430.445 434.534 430.692 434.569 430.921 434.516C431.141 434.463 431.344 434.34 431.476 434.164C431.608 433.988 431.696 433.776 431.705 433.556C431.705 433.547 431.705 433.538 431.696 433.538C431.696 433.538 431.679 433.538 431.679 433.556C431.661 433.917 431.432 434.225 431.106 434.384C430.877 434.499 430.604 434.507 430.366 434.41C430.128 434.314 429.934 434.102 429.864 433.855C429.785 433.591 429.829 433.318 429.97 433.107C430.111 432.895 430.331 432.754 430.569 432.728C430.736 432.71 430.895 432.728 431.044 432.781C431.194 432.833 431.326 432.93 431.432 433.062C431.485 433.133 431.52 433.203 431.555 433.274C431.582 433.353 431.608 433.433 431.617 433.521L431.635 433.538Z",
    fill: "#FFC727"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M431.458 433.538C431.432 433.327 431.326 433.151 431.168 433.027C431.009 432.913 430.815 432.851 430.604 432.869C430.41 432.886 430.216 433.001 430.093 433.168C429.969 433.336 429.917 433.574 429.978 433.811C430.022 434.005 430.154 434.173 430.331 434.27C430.498 434.366 430.71 434.393 430.886 434.349C431.071 434.305 431.229 434.199 431.335 434.058C431.441 433.917 431.511 433.741 431.52 433.565C431.52 433.565 431.52 433.547 431.511 433.547C431.511 433.547 431.494 433.547 431.494 433.565C431.476 433.855 431.291 434.102 431.027 434.234C430.85 434.331 430.621 434.34 430.428 434.261C430.234 434.181 430.075 434.014 430.022 433.811C429.961 433.6 430.005 433.371 430.119 433.203C430.234 433.036 430.419 432.93 430.604 432.913C430.736 432.904 430.859 432.913 430.983 432.957C431.097 433.001 431.212 433.071 431.291 433.177C431.335 433.23 431.361 433.283 431.388 433.344C431.414 433.406 431.432 433.468 431.441 433.538H431.458Z",
    fill: "#FFC727"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M436.268 435.961H410.021V440.983H436.268V435.961Z",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M436.329 441.045H409.96V435.899H436.329V441.045ZM410.083 440.921H436.206V436.023H410.083V440.921Z",
    fill: "#00A48C"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M415.413 435.961L413.51 440.983H410.118L412.03 435.961H415.413Z",
    fill: "#FFC727"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M422.364 435.961L420.461 440.983H417.069L418.972 435.961H422.364Z",
    fill: "#FFC727"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M429.316 435.961L427.404 440.983H424.021L425.924 435.961H429.316Z",
    fill: "#FFC727"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M436.259 435.961L434.356 440.983H430.964L432.867 435.961H436.259Z",
    fill: "#FFC727"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M435.732 447.124H410.552V450.304H435.732V447.124Z",
    fill: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M435.802 450.357H410.49V447.053H435.802V450.357ZM410.622 450.234H435.679V447.185H410.622V450.234Z",
    fill: "#00A48C"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M415.731 447.124L413.898 450.295H410.647L412.48 447.124H415.731Z",
    fill: "#FFC727"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M422.401 447.124L420.568 450.295H417.317L419.141 447.124H422.401Z",
    fill: "#FFC727"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M429.061 447.124L427.237 450.295H423.986L425.81 447.124H429.061Z",
    fill: "#FFC727"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M435.731 447.124L433.898 450.295H430.647L432.48 447.124H435.731Z",
    fill: "#FFC727"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M427.228 438.472C427.228 440.728 425.396 442.56 423.14 442.56C420.885 442.56 419.052 440.728 419.052 438.472C419.052 436.217 420.885 434.384 423.14 434.384C425.396 434.384 427.228 436.217 427.228 438.472Z",
    fill: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 442.622C420.859 442.622 419 440.763 419 438.472C419 436.182 420.859 434.323 423.15 434.323C425.44 434.323 427.299 436.182 427.299 438.472C427.299 440.763 425.44 442.622 423.15 442.622ZM423.15 434.455C420.929 434.455 419.132 436.261 419.132 438.481C419.132 440.702 420.938 442.499 423.15 442.499C425.361 442.499 427.167 440.693 427.167 438.481C427.167 436.27 425.361 434.455 423.15 434.455Z",
    fill: "#00A48C"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M426.612 438.473C426.612 440.385 425.062 441.935 423.15 441.935C421.238 441.935 419.687 440.385 419.687 438.473C419.687 436.561 421.238 435.01 423.15 435.01C425.062 435.01 426.612 436.561 426.612 438.473Z",
    fill: "#FFC727"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M425.317 438.076H420.973V438.878H425.317V438.076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsite);
export default __webpack_public_path__ + "static/media/projectsite.2eac0a9a98d27da244f64305128397c1.svg";
export { ForwardRef as ReactComponent };